import React from 'react'

import { IconBase, type IconBaseProps } from './IconBase'
import { makeIcon } from './makeIcon'

export const PenSmallIcon = makeIcon({
  displayName: 'PenSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.4883 10.5117L1.46687 8.69741L6.73845 3.42583L8.57417 5.26155L3.30259 10.5331L1.4883 10.5117ZM9.61057 4.22515L10.3912 3.44452C10.582 3.25372 10.582 2.94438 10.3912 2.75358L9.24642 1.6088C9.05562 1.418 8.74628 1.418 8.55548 1.6088L7.77485 2.38943L9.61057 4.22515ZM8.57156e-05 8.6142C-0.00381739 8.28378 0.12572 7.96575 0.359382 7.73208L7.51908 0.572391C8.28226 -0.190798 9.51964 -0.190796 10.2828 0.572392L11.4276 1.71718C12.1908 2.48037 12.1908 3.71774 11.4276 4.48093L4.26792 11.6406C4.03425 11.8743 3.71622 12.0038 3.3858 11.9999L0.993865 11.9717C0.463239 11.9654 0.0346089 11.5368 0.0283408 11.0061L8.57156e-05 8.6142Z"
      />
    </g>
  ),
})

export const BackArrowSmallIcon = makeIcon({
  displayName: 'ArrowBottomSmallIcon',
  viewBox: 12,
  content: (
    <g clipPath="url(#clip0_4625_529)">
      <path d="M10.4821 5.8972C10.4821 3.74483 8.73722 2 6.58486 2C4.98456 2 3.60844 2.9651 3.00866 4.34529L4.30017 4.02243C4.70201 3.92197 5.10921 4.16629 5.20967 4.56814C5.31013 4.96999 5.06581 5.37719 4.66396 5.47765L1.66397 6.22762C1.47004 6.2761 1.26479 6.24516 1.09377 6.14166C0.922754 6.03817 0.800127 5.87069 0.753113 5.6764L0.0211515 2.65154C-0.0762691 2.24895 0.171123 1.84361 0.573717 1.74619C0.976312 1.64877 1.38165 1.89616 1.47907 2.29875L1.76271 3.47089C2.65102 1.70874 4.47623 0.5 6.58486 0.5C9.56565 0.5 11.9821 2.91641 11.9821 5.8972C11.9821 8.87799 9.56565 11.2944 6.58486 11.2944C5.33681 11.2944 4.18581 10.8699 3.27135 10.1578C2.94453 9.90331 2.88589 9.43207 3.14038 9.10525C3.39486 8.77843 3.8661 8.71979 4.19292 8.97428C4.85331 9.48851 5.68231 9.79439 6.58486 9.79439C8.73722 9.79439 10.4821 8.04956 10.4821 5.8972Z" />
    </g>
  ),
})

export const ArrowBottomSmallIcon = makeIcon({
  displayName: 'ArrowBottomSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 1C6.66422 1 7 1.33579 7 1.75L7 7.40708L8.17219 6.21536C8.46266 5.92005 8.93359 5.92005 9.22405 6.21536C9.51452 6.51066 9.51452 6.98944 9.22405 7.28475L6.85706 9.69118C6.83471 9.72223 6.80974 9.75194 6.78215 9.77999C6.63534 9.92925 6.44242 10.0031 6.25 10.0014C6.05759 10.0031 5.86467 9.92925 5.71785 9.77999C5.69026 9.75194 5.6653 9.72223 5.64295 9.69119L3.27595 7.28475C2.98549 6.98944 2.98549 6.51066 3.27595 6.21536C3.56642 5.92005 4.03735 5.92005 4.32781 6.21536L5.5 7.40708L5.5 1.75C5.5 1.33579 5.83579 1 6.25 1Z"
    />
  ),
})
export const ArrowTopSmallIcon = makeIcon({
  displayName: 'ArrowTopSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.22405 5.09934C8.93359 5.39464 8.46266 5.39464 8.17219 5.09934L7 3.90761L7 9.56457C7 9.97879 6.66422 10.3146 6.25 10.3146C5.83579 10.3146 5.5 9.97879 5.5 9.56457L5.5 3.90761L4.32781 5.09934C4.03735 5.39464 3.56642 5.39464 3.27595 5.09934C2.98549 4.80403 2.98549 4.32525 3.27595 4.02995L5.64295 1.62351C5.66529 1.59247 5.69026 1.56276 5.71785 1.53471C5.86467 1.38544 6.0576 1.31163 6.25003 1.31326C6.44243 1.31164 6.63534 1.38546 6.78215 1.53471C6.80974 1.56276 6.83471 1.59246 6.85706 1.62351L9.22405 4.02995C9.51452 4.32525 9.51452 4.80404 9.22405 5.09934Z"
    />
  ),
})
export const GrabSmallIcon = makeIcon({
  displayName: 'GrabSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.877 1.5a1 1 0 00-1 1v1a1 1 0 001 1h1a1 1 0 001-1v-1a1 1 0 00-1-1h-1zm0 6a1 1 0 00-1 1v1a1 1 0 001 1h1a1 1 0 001-1v-1a1 1 0 00-1-1h-1zm5-5a1 1 0 011-1h1a1 1 0 011 1v1a1 1 0 01-1 1h-1a1 1 0 01-1-1v-1zm1 5a1 1 0 00-1 1v1a1 1 0 001 1h1a1 1 0 001-1v-1a1 1 0 00-1-1h-1z"
    />
  ),
})
export const CaretDownSmallIcon = makeIcon({
  displayName: 'CaretDownSmallIcon',
  viewBox: 12,
  content: (
    <path
      d="M3.3976 5.45956C2.92935 4.94704 3.29481 4.125 3.99091 4.125H8.38409C9.08019 4.125 9.44565 4.94704 8.9774 5.45956L6.78081 7.86384C6.46267 8.21205 5.91233 8.21205 5.59419 7.86384L3.3976 5.45956Z"
      fill="currentColor"
    />
  ),
})

export const CollapsedBlockSmallIcon = makeIcon({
  displayName: 'CollapsedBlockSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path d="M5 1.5C4.58579 1.5 4.25 1.83579 4.25 2.25C4.25 2.66421 4.58579 3 5 3H11.25C11.6642 3 12 2.66421 12 2.25C12 1.83579 11.6642 1.5 11.25 1.5H5Z" />
      <path d="M5 5.25C4.58579 5.25 4.25 5.58579 4.25 6C4.25 6.41421 4.58579 6.75 5 6.75H11.25C11.6642 6.75 12 6.41421 12 6C12 5.58579 11.6642 5.25 11.25 5.25H5Z" />
      <path d="M4.25 9.75C4.25 9.33579 4.58579 9 5 9H11.25C11.6642 9 12 9.33579 12 9.75C12 10.1642 11.6642 10.5 11.25 10.5H5C4.58579 10.5 4.25 10.1642 4.25 9.75Z" />
      <path d="M0.160717 2.03284C0.259404 1.98205 0.3782 1.99068 0.468515 2.05519L2.54259 3.53667C2.62045 3.59229 2.66667 3.68209 2.66667 3.77778C2.66667 3.87347 2.62045 3.96327 2.54259 4.01888L0.468515 5.50036C0.3782 5.56488 0.259404 5.5735 0.160717 5.52272C0.0620289 5.47193 0 5.37025 0 5.25926V2.2963C0 2.18531 0.0620289 2.08363 0.160717 2.03284Z" />
      <path d="M0.468515 6.49965C0.3782 6.43514 0.259404 6.42651 0.160717 6.4773C0.0620289 6.52808 0 6.62977 0 6.74076V9.70372C0 9.81471 0.0620289 9.91639 0.160717 9.96717C0.259404 10.018 0.3782 10.0093 0.468515 9.94482L2.54259 8.46334C2.62045 8.40772 2.66667 8.31793 2.66667 8.22224C2.66667 8.12655 2.62045 8.03675 2.54259 7.98113L0.468515 6.49965Z" />
    </g>
  ),
})

export const FilterSortDescSmallIcon = makeIcon({
  displayName: 'FilterSortDescSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <g clipPath="url(#clip0_2671_191)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.21967 0.46967C0.360322 0.329018 0.551088 0.25 0.75 0.25H10.75C11.1642 0.25 11.5 0.585786 11.5 1V2.81818C11.5 3.00187 11.4326 3.17917 11.3106 3.31645L10.4015 4.33918C10.1263 4.64877 9.65222 4.67665 9.34264 4.40147C9.03305 4.12628 9.00516 3.65222 9.28035 3.34264L10 2.53303V1.75H1.5V2.53303L4.94692 6.41082C5.06895 6.54811 5.13636 6.72541 5.13636 6.90909V10.75C5.13636 11.1642 4.80058 11.5 4.38636 11.5C3.97215 11.5 3.63636 11.1642 3.63636 10.75V7.19424L0.189443 3.31645C0.0674089 3.17917 0 3.00187 0 2.81818V1C0 0.801088 0.0790176 0.610322 0.21967 0.46967Z"
        />
        <line
          x1="9.25"
          y1="11.25"
          x2="9.25"
          y2="7.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="0.75"
          y1="-0.75"
          x2="3.5"
          y2="-0.75"
          transform="matrix(0.707107 -0.707107 -0.707107 -0.707107 6.25 8.25)"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="11.1893"
          y1="8.25"
          x2="9.2448"
          y2="6.30546"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2671_191">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </g>
  ),
})
export const FilterSortAscSmallIcon = makeIcon({
  displayName: 'FilterSortAscSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <g clipPath="url(#clip0_2547_573)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.21967 0.46967C0.360322 0.329018 0.551088 0.25 0.75 0.25H10.75C11.1642 0.25 11.5 0.585786 11.5 1V2.81818C11.5 3.00187 11.4326 3.17917 11.3106 3.31645L10.4015 4.33918C10.1263 4.64877 9.65222 4.67665 9.34264 4.40147C9.03305 4.12628 9.00516 3.65222 9.28035 3.34264L10 2.53303V1.75H1.5V2.53303L4.94692 6.41082C5.06895 6.54811 5.13636 6.72541 5.13636 6.90909V10.75C5.13636 11.1642 4.80058 11.5 4.38636 11.5C3.97215 11.5 3.63636 11.1642 3.63636 10.75V7.19424L0.189443 3.31645C0.0674089 3.17917 0 3.00187 0 2.81818V1C0 0.801088 0.0790176 0.610322 0.21967 0.46967Z"
        />
        <line
          x1="9.25"
          y1="6.25"
          x2="9.25"
          y2="10"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="0.75"
          y1="-0.75"
          x2="3.5"
          y2="-0.75"
          transform="matrix(-0.707107 0.707107 0.707107 0.707107 12.25 9.25)"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="7.31066"
          y1="9.25"
          x2="9.2552"
          y2="11.1945"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2547_573">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const NoteSmallIcon = makeIcon({
  displayName: 'NoteSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 2.25C0.5 1.00736 1.50736 0 2.75 0H9.25C10.4926 0 11.5 1.00736 11.5 2.25V9.75C11.5 10.9926 10.4926 12 9.25 12H2.75C1.50736 12 0.5 10.9926 0.5 9.75V2.25ZM2.75 1.5C2.33579 1.5 2 1.83579 2 2.25V9.75C2 10.1642 2.33579 10.5 2.75 10.5H9.25C9.66421 10.5 10 10.1642 10 9.75V5.5V2.25C10 1.83579 9.66421 1.5 9.25 1.5H2.75ZM4.25 3C3.83579 3 3.5 3.33579 3.5 3.75C3.5 4.16421 3.83579 4.5 4.25 4.5H7.75C8.16421 4.5 8.5 4.16421 8.5 3.75C8.5 3.33579 8.16421 3 7.75 3H4.25ZM3.5 6.25C3.5 5.83579 3.83579 5.5 4.25 5.5H6.25C6.66421 5.5 7 5.83579 7 6.25C7 6.66421 6.66421 7 6.25 7H4.25C3.83579 7 3.5 6.66421 3.5 6.25Z"
    />
  ),
})
export const PlusSmallIcon = makeIcon({
  displayName: 'PlusSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <g clipPath="url(#clip0_2465_329)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.1875 0C5.77329 0 5.4375 0.335786 5.4375 0.75V5.4375H0.75C0.335786 5.4375 0 5.77329 0 6.1875C0 6.60171 0.335786 6.9375 0.75 6.9375H5.4375V11.25C5.4375 11.6642 5.77329 12 6.1875 12C6.60171 12 6.9375 11.6642 6.9375 11.25V6.9375H11.25C11.6642 6.9375 12 6.60171 12 6.1875C12 5.77329 11.6642 5.4375 11.25 5.4375H6.9375V0.75C6.9375 0.335786 6.60171 0 6.1875 0Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2465_329">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const CalendarSmallIcon = makeIcon({
  displayName: 'CalendarSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 3.25C0 2.2835 0.783502 1.5 1.75 1.5H10.25C11.2165 1.5 12 2.2835 12 3.25V10.25C12 11.2165 11.2165 12 10.25 12H1.75C0.783502 12 0 11.2165 0 10.25V3.25ZM1.75 3C1.61193 3 1.5 3.11193 1.5 3.25V10.25C1.5 10.3881 1.61193 10.5 1.75 10.5H10.25C10.3881 10.5 10.5 10.3881 10.5 10.25V6.75V3.25C10.5 3.11193 10.3881 3 10.25 3H1.75Z"
      />
      <path d="M2.75 0.75C2.75 0.335786 3.08579 0 3.5 0C3.91421 0 4.15 0.335786 4.15 0.75V4.25C4.15 4.66421 3.91421 5 3.5 5C3.08579 5 2.75 4.66421 2.75 4.25V0.75Z" />
      <path d="M7.75 0.75C7.75 0.335786 8.08579 0 8.5 0C8.91421 0 9.25 0.335786 9.25 0.75V4.25C9.25 4.66421 8.91421 5 8.5 5C8.08579 5 7.75 4.66421 7.75 4.25V0.75Z" />
    </g>
  ),
})

export const CheckboxSmallIcon = makeIcon({
  displayName: 'CheckboxSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 2.25C1.5 1.83579 1.83579 1.5 2.25 1.5H6.875C7.28921 1.5 7.625 1.16421 7.625 0.75C7.625 0.335786 7.28921 0 6.875 0H2.25C1.00736 0 0 1.00736 0 2.25V9.75C0 10.9926 1.00736 12 2.25 12H9.75C10.9926 12 12 10.9926 12 9.75V6.07955C12 5.66533 11.6642 5.32955 11.25 5.32955C10.8358 5.32955 10.5 5.66533 10.5 6.07955V9.75C10.5 10.1642 10.1642 10.5 9.75 10.5H2.25C1.83579 10.5 1.5 10.1642 1.5 9.75V2.25ZM11.7803 2.23492C12.0732 1.94203 12.0732 1.46715 11.7803 1.17426C11.4874 0.881367 11.0126 0.881367 10.7197 1.17426L5.52274 6.3712L4.14398 4.99244C3.85108 4.69955 3.37621 4.69955 3.08332 4.99244C2.79042 5.28533 2.79042 5.76021 3.08332 6.0531L4.99241 7.96219C5.2853 8.25509 5.76018 8.25509 6.05307 7.96219L11.7803 2.23492Z"
      />
    </g>
  ),
})

export const CheckmarkSmallIcon = makeIcon({
  displayName: 'checkmarkSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3011 1.99129C11.5821 2.29566 11.5631 2.77015 11.2587 3.05111L4.75871 9.05111C4.46291 9.32415 4.00432 9.31498 3.71967 9.03033L0.71967 6.03033C0.426777 5.73744 0.426777 5.26257 0.71967 4.96967C1.01256 4.67678 1.48744 4.67678 1.78033 4.96967L4.27079 7.46013L10.2413 1.9489C10.5457 1.66795 11.0202 1.68693 11.3011 1.99129Z"
    />
  ),
})

export const EyeSmallIcon = makeIcon({
  displayName: 'EyeSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.6046 6C1.63118 5.95571 1.66079 5.90769 1.69345 5.85649C1.88178 5.56127 2.16708 5.16754 2.55216 4.7757C3.32267 3.99167 4.45413 3.25 6 3.25C7.54587 3.25 8.67733 3.99167 9.44784 4.7757C9.83292 5.16754 10.1182 5.56127 10.3066 5.85649C10.3392 5.90769 10.3688 5.95571 10.3954 6C10.3688 6.04428 10.3392 6.09231 10.3066 6.14351C10.1182 6.43873 9.83292 6.83246 9.44784 7.2243C8.67733 8.00833 7.54587 8.75 6 8.75C4.45413 8.75 3.32267 8.00833 2.55216 7.2243C2.16708 6.83246 1.88178 6.43873 1.69345 6.14351C1.66079 6.09231 1.63118 6.04429 1.6046 6ZM11.25 6C11.9299 5.68348 11.9297 5.68287 11.9297 5.68287L11.9286 5.68057L11.9266 5.67637L11.9208 5.6642C11.9161 5.65443 11.9097 5.64139 11.9016 5.62528C11.8855 5.59308 11.8627 5.54858 11.833 5.49355C11.7737 5.38358 11.6867 5.23092 11.5711 5.04976C11.3408 4.68873 10.9925 4.20746 10.5177 3.7243C9.56836 2.75833 8.07482 1.75 6 1.75C3.92518 1.75 2.43164 2.75833 1.48232 3.7243C1.00749 4.20746 0.659168 4.68873 0.428856 5.04976C0.313294 5.23092 0.226305 5.38358 0.166989 5.49355C0.137303 5.54858 0.114462 5.59308 0.0983615 5.62528C0.0903086 5.64139 0.0839336 5.65443 0.0792236 5.6642L0.0734026 5.67637L0.0714236 5.68057L0.0706662 5.68219C0.0706662 5.68219 0.0700635 5.68348 0.75 6L0.0700635 5.68348C-0.0233545 5.88415 -0.0233545 6.11585 0.0700635 6.31652L0.75 6C0.0700635 6.31652 0.0700635 6.31652 0.0700635 6.31652L0.0706662 6.31781L0.0714236 6.31943L0.0734026 6.32363L0.0792236 6.3358C0.0839336 6.34556 0.0903086 6.35861 0.0983615 6.37472C0.114462 6.40692 0.137303 6.45142 0.166989 6.50645C0.226305 6.61642 0.313294 6.76908 0.428856 6.95024C0.659168 7.31127 1.00749 7.79254 1.48232 8.2757C2.43164 9.24167 3.92518 10.25 6 10.25C8.07482 10.25 9.56836 9.24167 10.5177 8.2757C10.9925 7.79254 11.3408 7.31127 11.5711 6.95024C11.6867 6.76908 11.7737 6.61642 11.833 6.50645C11.8627 6.45142 11.8855 6.40692 11.9016 6.37472C11.9097 6.35861 11.9161 6.34556 11.9208 6.3358L11.9266 6.32363L11.9286 6.31943L11.9293 6.31781C11.9293 6.31781 11.9299 6.31652 11.25 6ZM11.25 6L11.9299 6.31652C12.0234 6.11585 12.0231 5.88355 11.9297 5.68287L11.25 6Z"
      />
      <path d="M7.5 6C7.5 6.82843 6.82843 7.5 6 7.5C5.17157 7.5 4.5 6.82843 4.5 6C4.5 5.17157 5.17157 4.5 6 4.5C6.82843 4.5 7.5 5.17157 7.5 6Z" />
    </g>
  ),
})

export const EyeCrossedSmallIcon = makeIcon({
  displayName: 'EyeCrossedSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5303 1.53033C11.8232 1.23744 11.8232 0.762563 11.5303 0.46967C11.2374 0.176777 10.7626 0.176777 10.4697 0.46967L0.46967 10.4697C0.176777 10.7626 0.176777 11.2374 0.46967 11.5303C0.762563 11.8232 1.23744 11.8232 1.53033 11.5303L3.39796 9.6627C3.40831 9.66817 3.41883 9.67343 3.42952 9.67847C4.16228 10.0237 5.01957 10.25 6 10.25C8.07482 10.25 9.56836 9.24167 10.5177 8.2757C10.9925 7.79254 11.3408 7.31127 11.5711 6.95024C11.6867 6.76908 11.7737 6.61642 11.833 6.50645C11.8627 6.45142 11.8855 6.40692 11.9016 6.37472C11.9097 6.35861 11.9161 6.34556 11.9208 6.3358L11.9266 6.32363L11.9286 6.31943L11.9297 6.31713C12.0231 6.11645 12.023 5.88335 11.9296 5.68268L11.9291 5.68174L11.9281 5.67947L11.9251 5.67331L11.9162 5.65474C11.9088 5.63963 11.8987 5.61913 11.8857 5.59371C11.8597 5.5429 11.8224 5.4723 11.7734 5.38573C11.6757 5.21285 11.5308 4.97475 11.3367 4.70253C11.01 4.24421 10.5349 3.67657 9.89928 3.16138L11.5303 1.53033ZM8.83124 4.22942L7.44919 5.61147C7.48233 5.73539 7.5 5.86563 7.5 6C7.5 6.82843 6.82843 7.5 6 7.5C5.86563 7.5 5.73539 7.48233 5.61147 7.44919L4.54633 8.51433C4.98025 8.66123 5.4634 8.75 6 8.75C7.54587 8.75 8.67733 8.00833 9.44784 7.2243C9.83292 6.83246 10.1182 6.43873 10.3066 6.14351C10.3392 6.09231 10.3688 6.04428 10.3954 6C10.3239 5.88089 10.2307 5.73509 10.1153 5.57328C9.82153 5.16114 9.39467 4.66005 8.83124 4.22942ZM11.25 6C11.9299 6.31652 11.9297 6.31713 11.9297 6.31713L11.25 6ZM11.9296 5.68268C11.9296 5.68268 11.9299 5.68348 11.25 6L11.9296 5.68268Z"
      />
      <path d="M1.69345 5.85649C1.66079 5.90769 1.63118 5.95571 1.6046 6C1.69405 6.14906 1.81738 6.33965 1.97534 6.55092C2.22335 6.88268 2.15547 7.35267 1.82372 7.60069C1.49197 7.84871 1.02197 7.78083 0.773951 7.44908C0.542465 7.13943 0.370171 6.86389 0.254368 6.66296C0.196365 6.56232 0.152235 6.47988 0.121676 6.42061C0.106388 6.39095 0.0944705 6.36705 0.0858866 6.34951L0.0754973 6.32803L0.0721631 6.321L0.0709593 6.31844L0.0700635 6.31652C-0.0233545 6.11585 -0.0233545 5.88415 0.0700635 5.68348L0.75 6C0.0700635 5.68348 0.0706663 5.68219 0.0706663 5.68219L0.0714236 5.68057L0.0734027 5.67637L0.0792237 5.6642C0.0839336 5.65444 0.0903086 5.64139 0.0983615 5.62528C0.114462 5.59308 0.137303 5.54858 0.166989 5.49355C0.226305 5.38358 0.313294 5.23092 0.428856 5.04976C0.659168 4.68873 1.00749 4.20746 1.48232 3.7243C2.43164 2.75833 3.92518 1.75 6 1.75C6.41421 1.75 6.75 2.08579 6.75 2.5C6.75 2.91421 6.41421 3.25 6 3.25C4.45413 3.25 3.32267 3.99167 2.55216 4.7757C2.16708 5.16754 1.88178 5.56127 1.69345 5.85649Z" />
    </g>
  ),
})

export const PlaceholderSmallIcon = makeIcon({
  displayName: 'PlaceholderSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.25C0 1.00736 1.00736 0 2.25 0H2.375C2.78921 0 3.125 0.335786 3.125 0.75C3.125 1.16421 2.78921 1.5 2.375 1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V2.375C1.5 2.78921 1.16421 3.125 0.75 3.125C0.335786 3.125 0 2.78921 0 2.375V2.25ZM4.25 0.75C4.25 0.335786 4.58579 0 5 0H7C7.41421 0 7.75 0.335786 7.75 0.75C7.75 1.16421 7.41421 1.5 7 1.5H5C4.58579 1.5 4.25 1.16421 4.25 0.75ZM8.875 0.75C8.875 0.335786 9.21079 0 9.625 0H9.75C10.9926 0 12 1.00736 12 2.25V2.375C12 2.78921 11.6642 3.125 11.25 3.125C10.8358 3.125 10.5 2.78921 10.5 2.375V2.25C10.5 1.83579 10.1642 1.5 9.75 1.5H9.625C9.21079 1.5 8.875 1.16421 8.875 0.75ZM0.75 4.75C1.16421 4.75 1.5 5.08579 1.5 5.5V7C1.5 7.41421 1.16421 7.75 0.75 7.75C0.335786 7.75 0 7.41421 0 7V5.5C0 5.08579 0.335786 4.75 0.75 4.75ZM11.25 4.75C11.6642 4.75 12 5.08579 12 5.5V7C12 7.41421 11.6642 7.75 11.25 7.75C10.8358 7.75 10.5 7.41421 10.5 7V5.5C10.5 5.08579 10.8358 4.75 11.25 4.75ZM0.75 8.875C1.16421 8.875 1.5 9.21079 1.5 9.625V9.75C1.5 10.1642 1.83579 10.5 2.25 10.5H2.375C2.78921 10.5 3.125 10.8358 3.125 11.25C3.125 11.6642 2.78921 12 2.375 12H2.25C1.00736 12 0 10.9926 0 9.75V9.625C0 9.21079 0.335786 8.875 0.75 8.875ZM11.25 8.875C11.6642 8.875 12 9.21079 12 9.625V9.75C12 10.9926 10.9926 12 9.75 12H9.625C9.21079 12 8.875 11.6642 8.875 11.25C8.875 10.8358 9.21079 10.5 9.625 10.5H9.75C10.1642 10.5 10.5 10.1642 10.5 9.75V9.625C10.5 9.21079 10.8358 8.875 11.25 8.875ZM4.25 11.25C4.25 10.8358 4.58579 10.5 5 10.5H7C7.41421 10.5 7.75 10.8358 7.75 11.25C7.75 11.6642 7.41421 12 7 12H5C4.58579 12 4.25 11.6642 4.25 11.25Z"
      />
    </g>
  ),
})

export const MentionSmallIcon = makeIcon({
  displayName: 'MentionSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.84696 11.1033 9.1093 9.88818 9.3589C9.29413 9.48092 8.67486 9.33271 8.20855 8.90717C8.08361 8.79316 7.97413 8.66346 7.88088 8.52016C7.38188 8.97631 6.72953 9.25781 6 9.25781C4.35047 9.25781 3.10781 7.82672 3.10781 6.18281C3.10781 4.53891 4.35047 3.10781 6 3.10781C6.59965 3.10781 7.1476 3.29809 7.60098 3.61958C7.72432 3.42208 7.94357 3.29063 8.19375 3.29063C8.57949 3.29063 8.89219 3.60333 8.89219 3.98906V7.09688C8.89219 7.53791 9.03291 7.76837 9.15014 7.87535C9.26676 7.98178 9.42452 8.0281 9.60713 7.99059C9.94806 7.92056 10.6031 7.44379 10.6031 6C10.6031 3.45776 8.54224 1.39688 6 1.39688C3.45776 1.39688 1.39687 3.45776 1.39687 6C1.39687 6.82755 1.61512 7.60367 1.99709 8.27443C2.00276 8.28331 2.00826 8.29236 2.01358 8.30157C2.43009 9.02299 3.0122 9.58879 3.68415 9.97904C4.24013 10.3019 4.8577 10.5047 5.49381 10.5756C5.65999 10.5938 5.82888 10.6031 6 10.6031C6.01154 10.6031 6.02302 10.6034 6.03445 10.604C6.55527 10.6006 7.08022 10.5086 7.58655 10.322C7.94847 10.1886 8.35003 10.3738 8.48345 10.7357C8.61687 11.0977 8.43163 11.4992 8.0697 11.6326C7.21668 11.9471 6.32325 12.0556 5.45369 11.9755C4.57174 11.8958 3.74471 11.6253 3.01442 11.2056C2.28725 10.7894 1.63935 10.2162 1.12682 9.50106C0.417707 8.51573 0 7.30642 0 6ZM6 4.50469C5.22472 4.50469 4.50469 5.20343 4.50469 6.18281C4.50469 7.16219 5.22472 7.86094 6 7.86094C6.77528 7.86094 7.49531 7.16219 7.49531 6.18281C7.49531 5.20343 6.77528 4.50469 6 4.50469Z"
      />
    </g>
  ),
})

export const MinimizeSmallIcon = makeIcon({
  displayName: 'MinimizeSmallIcon',
  viewBox: 12,
  content: (
    <rect x="1" y="5" width="10" height="2" rx="1" fill="currentColor" />
  ),
})

export const MoreSmallIcon = makeIcon({
  displayName: 'MoreSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 1.5C7.5 2.32843 6.82843 3 6 3C5.17157 3 4.5 2.32843 4.5 1.5C4.5 0.671573 5.17157 0 6 0C6.82843 0 7.5 0.671573 7.5 1.5ZM7.5 6C7.5 6.82843 6.82843 7.5 6 7.5C5.17157 7.5 4.5 6.82843 4.5 6C4.5 5.17157 5.17157 4.5 6 4.5C6.82843 4.5 7.5 5.17157 7.5 6ZM6 12C6.82843 12 7.5 11.3284 7.5 10.5C7.5 9.67157 6.82843 9 6 9C5.17157 9 4.5 9.67157 4.5 10.5C4.5 11.3284 5.17157 12 6 12Z"
    />
  ),
})

export const GlobeSmallIcon = makeIcon({
  displayName: 'GlobeSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.22357 10.0278C9.35992 9.39919 10.202 8.30362 10.491 7H8.95852C8.86168 8.15444 8.60001 9.19709 8.22357 10.0278ZM6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM3.77643 1.97215C2.46958 2.69514 1.5519 4.03567 1.41715 5.6H3.00656C3.05239 4.20742 3.33578 2.94461 3.77643 1.97215ZM4.4074 5.6C4.45632 4.28478 4.74304 3.15913 5.13088 2.38346C5.59936 1.4465 5.98753 1.4 6 1.4C6.01247 1.4 6.40064 1.4465 6.86912 2.38346C7.25696 3.15913 7.54368 4.28478 7.5926 5.6H4.4074ZM4.44704 7C4.54807 8.05729 4.80343 8.96165 5.13088 9.61654C5.59936 10.5535 5.98753 10.6 6 10.6C6.01247 10.6 6.40064 10.5535 6.86912 9.61654C7.19657 8.96165 7.45193 8.05729 7.55296 7H4.44704ZM3.04148 7C3.13832 8.15444 3.39999 9.19709 3.77643 10.0278C2.64008 9.39919 1.79799 8.30362 1.509 7H3.04148ZM8.99344 5.6C8.94761 4.20742 8.66422 2.94461 8.22357 1.97215C9.53043 2.69514 10.4481 4.03567 10.5829 5.6H8.99344Z"
      />
    </g>
  ),
})

export const GlobeStrikedThroughSmallIcon = makeIcon({
  displayName: 'GlobeStrikedThrough',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.79564 0.689733C7.9608 0.249315 7.00951 0 6 0C2.68629 0 0 2.68629 0 6C0 7.00951 0.249315 7.9608 0.689733 8.79564L1.7419 7.74347C1.64416 7.50501 1.56587 7.25652 1.509 6.99998H2.48539L4.44309 5.04228C4.54128 3.96682 4.79908 3.04706 5.13088 2.38346C5.59936 1.4465 5.98753 1.4 6 1.4C6.01247 1.4 6.40064 1.4465 6.86912 2.38346C6.89464 2.43449 6.91972 2.48704 6.94432 2.54105L8.79564 0.689733ZM3.77643 1.97215C2.46958 2.69514 1.55191 4.03566 1.41715 5.59998H3.00656C3.05239 4.20741 3.33578 2.94461 3.77643 1.97215Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.0323 10.5744C0.830449 10.8666 0.859571 11.2702 1.11967 11.5303C1.41256 11.8232 1.88744 11.8232 2.18033 11.5303L2.69932 11.0113C3.6462 11.6362 4.78062 12 6 12C9.31371 12 12 9.31371 12 6C12 4.78062 11.6362 3.6462 11.0113 2.69932L11.3727 2.33794C11.6656 2.04505 11.6656 1.57018 11.3727 1.27728C11.1126 1.01718 10.709 0.988061 10.4168 1.18991L1.0323 10.5744ZM8.99344 5.59998C8.98418 5.31872 8.96523 5.04275 8.93726 4.7734L9.99412 3.71654C10.3171 4.28027 10.5242 4.91891 10.5828 5.59998H8.99344ZM6.71068 6.99998L4.83003 8.88063C4.92023 9.15136 5.02154 9.39786 5.13088 9.61654C5.59936 10.5535 5.98753 10.6 6 10.6C6.01247 10.6 6.40064 10.5535 6.86912 9.61654C7.19657 8.96165 7.45194 8.05728 7.55297 6.99998H6.71068ZM8.22357 10.0278C9.35992 9.39918 10.202 8.3036 10.491 6.99998H8.95852C8.86169 8.15442 8.60001 9.19708 8.22357 10.0278Z"
      />
    </g>
  ),
})

export const CloseSmallIcon = makeIcon({
  displayName: 'CloseSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.53034 1.53022C1.23745 1.82311 1.23745 2.29798 1.53034 2.59088L4.93862 5.99915L1.53038 9.40739C1.23749 9.70028 1.23749 10.1752 1.53038 10.468C1.82328 10.7609 2.29815 10.7609 2.59104 10.468L5.99928 7.05981L9.40751 10.468C9.7004 10.7609 10.1753 10.7609 10.4682 10.468C10.7611 10.1752 10.7611 9.70028 10.4682 9.40739L7.05994 5.99915L10.4682 2.59088C10.7611 2.29798 10.7611 1.82311 10.4682 1.53022C10.1753 1.23732 9.70045 1.23732 9.40755 1.53022L5.99928 4.93849L2.591 1.53022C2.29811 1.23732 1.82323 1.23732 1.53034 1.53022Z"
      />
    </g>
  ),
})

export const NumberSmallIcon = makeIcon({
  displayName: 'NumberSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.6272 12C4.21298 12 3.8772 11.6642 3.8772 11.25V9H1.1272C0.712984 9 0.377197 8.66421 0.377197 8.25C0.377197 7.83579 0.712984 7.5 1.1272 7.5H3.8772V5H1.1272C0.712984 5 0.377197 4.66421 0.377197 4.25C0.377197 3.83579 0.712984 3.5 1.1272 3.5H3.8772L3.8772 0.75C3.8772 0.335787 4.21298 0 4.6272 0C5.04141 0 5.3772 0.335787 5.3772 0.75V3.5H7.8772V0.75C7.8772 0.335787 8.21298 0 8.6272 0C9.04141 0 9.3772 0.335787 9.3772 0.75V3.5H11.6272C12.0414 3.5 12.3772 3.83579 12.3772 4.25C12.3772 4.66421 12.0414 5 11.6272 5H9.3772L9.3772 7.5H11.6272C12.0414 7.5 12.3772 7.83579 12.3772 8.25C12.3772 8.66421 12.0414 9 11.6272 9H9.3772V11.25C9.3772 11.6642 9.04141 12 8.6272 12C8.21298 12 7.8772 11.6642 7.8772 11.25V9H5.3772V11.25C5.3772 11.6642 5.04141 12 4.6272 12ZM7.8772 7.5L7.8772 5H5.3772L5.3772 7.5H7.8772Z"
      />
    </g>
  ),
})

export const RecycleSmallIcon = makeIcon({
  displayName: 'RefreshSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <g clipPath="url(#clip0_2589_240)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.021 7.3a4.141 4.141 0 01-7.69.928H4.12a.75.75 0 100-1.5H.75a.75.75 0 00-.75.75v3.369a.75.75 0 001.5 0V9.708a5.641 5.641 0 009.979-2.052.75.75 0 00-1.457-.356zM1.928 4.7a4.141 4.141 0 017.69-.928H7.831a.75.75 0 000 1.5H11.2a.75.75 0 00.75-.75V1.153a.75.75 0 00-1.5 0v1.139A5.641 5.641 0 00.472 4.344a.75.75 0 101.456.356z"
        />
      </g>
      <defs>
        <clipPath id="clip0_2589_240">
          <path d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const ArchiveSmallIcon = makeIcon({
  displayName: 'ArchiveSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path d="M4.875 6.25C4.46079 6.25 4.125 6.58579 4.125 7C4.125 7.41421 4.46079 7.75 4.875 7.75H7.125C7.53921 7.75 7.875 7.41421 7.875 7C7.875 6.58579 7.53921 6.25 7.125 6.25H4.875Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2C0 1.17157 0.671573 0.5 1.5 0.5H10.5C11.3284 0.5 12 1.17157 12 2V3.5C12 4.15311 11.5826 4.70873 11 4.91465V9.875C11 10.9105 10.1605 11.75 9.125 11.75H2.875C1.83947 11.75 1 10.9105 1 9.875V4.91465C0.417404 4.70873 0 4.15311 0 3.5V2ZM2.5 5H9.5V9.875C9.5 10.0821 9.33211 10.25 9.125 10.25H2.875C2.66789 10.25 2.5 10.0821 2.5 9.875V5ZM10.5 2H1.5V3.5H10.5V2Z"
      />
    </g>
  ),
})

export const ArobaseSmallIcon = makeIcon({
  displayName: 'ArobaseSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.84696 11.1033 9.1093 9.88818 9.3589C9.29413 9.48092 8.67486 9.33271 8.20855 8.90717C8.08361 8.79316 7.97413 8.66346 7.88088 8.52016C7.38188 8.97631 6.72953 9.25781 6 9.25781C4.35047 9.25781 3.10781 7.82672 3.10781 6.18281C3.10781 4.53891 4.35047 3.10781 6 3.10781C6.59965 3.10781 7.1476 3.29809 7.60098 3.61958C7.72432 3.42208 7.94357 3.29063 8.19375 3.29063C8.57949 3.29063 8.89219 3.60333 8.89219 3.98906V7.09688C8.89219 7.53791 9.03291 7.76837 9.15014 7.87535C9.26676 7.98178 9.42452 8.0281 9.60713 7.99059C9.94806 7.92056 10.6031 7.44379 10.6031 6C10.6031 3.45776 8.54224 1.39688 6 1.39688C3.45776 1.39688 1.39687 3.45776 1.39687 6C1.39687 6.82755 1.61512 7.60367 1.99709 8.27443C2.00276 8.28331 2.00826 8.29236 2.01358 8.30157C2.43009 9.02299 3.0122 9.58879 3.68415 9.97904C4.24013 10.3019 4.8577 10.5047 5.49381 10.5756C5.65999 10.5938 5.82888 10.6031 6 10.6031C6.01154 10.6031 6.02302 10.6034 6.03445 10.604C6.55527 10.6006 7.08022 10.5086 7.58655 10.322C7.94847 10.1886 8.35003 10.3738 8.48345 10.7357C8.61687 11.0977 8.43163 11.4992 8.0697 11.6326C7.21668 11.9471 6.32325 12.0556 5.45369 11.9755C4.57174 11.8958 3.74471 11.6253 3.01442 11.2056C2.28725 10.7894 1.63935 10.2162 1.12682 9.50106C0.417707 8.51573 0 7.30642 0 6ZM6 4.50469C5.22472 4.50469 4.50469 5.20343 4.50469 6.18281C4.50469 7.16219 5.22472 7.86094 6 7.86094C6.77528 7.86094 7.49531 7.16219 7.49531 6.18281C7.49531 5.20343 6.77528 4.50469 6 4.50469Z"
    />
  ),
})

export const SearchSmallIcon = makeIcon({
  displayName: 'SearchSmallIcon',
  viewBox: 12,
  content: (
    <path d="M3.633 2.75a3.633 3.633 0 1 0 1.983 6.677l2.291 2.291a.75.75 0 0 0 1.06-1.06l-2.29-2.291A3.633 3.633 0 0 0 3.633 2.75ZM1.5 6.383a2.133 2.133 0 1 1 4.266 0 2.133 2.133 0 0 1-4.266 0ZM5.75 1.313a.75.75 0 0 1 .75-.75h4.75a.75.75 0 0 1 0 1.5H6.5a.75.75 0 0 1-.75-.75ZM8.25 4.313a.75.75 0 0 1 .75-.75h2.25a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM9.25 7.313a.75.75 0 0 1 .75-.75h1.25a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.75-.75Z" />
  ),
})

export const TagSmallIcon = makeIcon({
  displayName: 'TagSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.84924 1.78729C8.92313 1.78057 8.99618 1.80702 9.04865 1.85949L10.1332 2.94407C10.1857 2.99654 10.2121 3.06959 10.2054 3.14348L10.031 5.06171C10.0258 5.11995 10.0002 5.1745 9.95885 5.21585L4.80757 10.3671C4.70994 10.4648 4.55165 10.4648 4.45402 10.3671L1.62559 7.5387C1.52796 7.44107 1.52796 7.28278 1.62559 7.18515L6.77687 2.03387C6.81822 1.99252 6.87277 1.96697 6.93101 1.96167L8.84924 1.78729ZM10.1093 0.798826C9.74206 0.43158 9.23067 0.246429 8.71343 0.29345L6.79521 0.467834C6.3875 0.504898 6.00569 0.683728 5.71621 0.97321L0.564931 6.12449C-0.118486 6.80791 -0.118486 7.91595 0.564931 8.59936L3.39336 11.4278C4.07678 12.1112 5.18481 12.1112 5.86823 11.4278L11.0195 6.27651C11.309 5.98703 11.4878 5.60522 11.5249 5.19751L11.6993 3.27929C11.7463 2.76206 11.5611 2.25066 11.1939 1.88341L10.1093 0.798826ZM7.71962 4.28035C8.01251 4.57324 8.48739 4.57324 8.78028 4.28035C9.07317 3.98745 9.07317 3.51258 8.78028 3.21969C8.48739 2.92679 8.01251 2.92679 7.71962 3.21969C7.42673 3.51258 7.42673 3.98745 7.71962 4.28035Z"
      />
    </g>
  ),
})

export const TagsSmallIcon = makeIcon({
  displayName: 'TagsSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.15205 1.61266C8.09958 1.5602 8.02653 1.53375 7.95264 1.54046L6.35694 1.68553C6.2987 1.69082 6.24415 1.71637 6.2028 1.75772L1.76988 6.19064C1.67225 6.28828 1.67225 6.44657 1.76988 6.5442L4.09985 8.87417C4.19748 8.9718 4.35577 8.9718 4.45341 8.87417L8.88633 4.44125C8.92768 4.3999 8.95323 4.34535 8.95852 4.28711L9.10359 2.69141C9.1103 2.61752 9.08385 2.54447 9.03139 2.492L8.15205 1.61266ZM7.81683 0.0466239C8.33407 -0.000397231 8.84546 0.184754 9.21271 0.552L10.0921 1.43134C10.3862 1.72545 10.5635 2.11202 10.5983 2.51999L11.0887 2.91931C11.428 3.19553 11.6515 3.5888 11.7151 4.02161L11.9256 5.45192C11.9793 5.81664 11.9164 6.18899 11.7459 6.51586L9.52465 10.7754C9.0652 11.6564 7.96523 11.9786 7.10304 11.4846L5.01125 10.2863C4.36436 10.5853 3.57249 10.4681 3.03919 9.93483L0.709219 7.60486C0.0258022 6.92144 0.0257996 5.8134 0.709218 5.12998L5.14214 0.697063C5.43162 0.407582 5.81343 0.228751 6.22114 0.191687L7.81683 0.0466239ZM9.94699 5.50191C10.1139 5.33498 10.2441 5.13734 10.3314 4.92174L10.4416 5.67028C10.4492 5.72239 10.4403 5.77558 10.4159 5.82228L8.19463 10.0818C8.129 10.2076 7.97186 10.2537 7.84869 10.1831L6.20656 9.24234L9.94699 5.50191ZM7.18306 3.31694C7.42714 3.56102 7.82286 3.56102 8.06694 3.31694C8.31102 3.07286 8.31102 2.67714 8.06694 2.43306C7.82286 2.18898 7.42714 2.18898 7.18306 2.43306C6.93898 2.67714 6.93898 3.07286 7.18306 3.31694Z"
      />
    </g>
  ),
})

export const PeopleSmallIcon = makeIcon({
  displayName: 'PeopleSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 2.75C4.75 2.05964 5.30964 1.5 6 1.5C6.69036 1.5 7.25 2.05964 7.25 2.75C7.25 3.44036 6.69036 4 6 4C5.30964 4 4.75 3.44036 4.75 2.75ZM6 0C4.48122 0 3.25 1.23122 3.25 2.75C3.25 4.26878 4.48122 5.5 6 5.5C7.51878 5.5 8.75 4.26878 8.75 2.75C8.75 1.23122 7.51878 0 6 0ZM2.7511 8.85698C3.03541 8.55716 3.51512 8.33013 4.14271 8.18535C4.75682 8.04369 5.42782 8 5.99999 8C6.57216 8 7.24316 8.04369 7.85726 8.18535C8.48485 8.33013 8.96456 8.55716 9.24887 8.85698C9.48756 9.10869 9.70683 9.53112 9.88615 10.0158C9.93013 10.1346 9.90797 10.2364 9.83892 10.3242C9.76324 10.4204 9.62566 10.5 9.44826 10.5H2.55171C2.37431 10.5 2.23673 10.4204 2.16106 10.3242C2.092 10.2364 2.06984 10.1346 2.11383 10.0158C2.29315 9.53112 2.51241 9.10869 2.7511 8.85698ZM0.707035 9.49524C0.209805 10.8391 1.32292 12 2.55171 12H9.44826C10.6771 12 11.7902 10.8391 11.2929 9.49524C11.0917 8.95136 10.7873 8.2994 10.3373 7.82484C9.75955 7.21557 8.94616 6.89715 8.19443 6.72374C7.42923 6.54722 6.63471 6.5 5.99999 6.5C5.36526 6.5 4.57074 6.54722 3.80554 6.72374C3.05382 6.89715 2.24042 7.21557 1.66267 7.82484C1.21265 8.2994 0.908275 8.95136 0.707035 9.49524Z"
      />
    </g>
  ),
})

export const TextSmallIcon = makeIcon({
  displayName: 'TextSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.627197 1C0.627197 0.585786 0.962984 0.25 1.3772 0.25H11.3772C11.7914 0.25 12.1272 0.585786 12.1272 1V4.11111C12.1272 4.52532 11.7914 4.86111 11.3772 4.86111C10.963 4.86111 10.6272 4.52532 10.6272 4.11111V1.75H7.1272V10.25H9.4572C9.87141 10.25 10.2072 10.5858 10.2072 11C10.2072 11.4142 9.87141 11.75 9.4572 11.75H3.2972C2.88298 11.75 2.5472 11.4142 2.5472 11C2.5472 10.5858 2.88298 10.25 3.2972 10.25H5.6272V1.75H2.1272V4.11111C2.1272 4.52532 1.79141 4.86111 1.3772 4.86111C0.962984 4.86111 0.627197 4.52532 0.627197 4.11111V1Z"
      />
    </g>
  ),
})

export const FormatSmallIcon = makeIcon({
  displayName: 'FormatSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.779 0a.75.75 0 0 0-.703.487l-3.928 10.5a.75.75 0 1 0 1.405.526l.983-2.629h4.878l.984 2.629a.75.75 0 1 0 1.405-.526L6.874.487A.75.75 0 0 0 6.172 0h-.393Zm2.074 7.384L5.975 2.365 4.097 7.384h3.756Z"
      fill="currentColor"
    />
  ),
})

export const BucketSmallIcon = makeIcon({
  displayName: 'BucketSmallIcon',
  viewBox: 12,
  content: (
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.19.325A.75.75 0 0 1 3.25.302l1.073 1.029.789-.789a1.529 1.529 0 0 1 2.162 0l3.548 3.549a1.529 1.529 0 0 1 0 2.162l-4.601 4.602a1.529 1.529 0 0 1-2.162 0L.509 7.306a1.529 1.529 0 0 1 0-2.162l2.753-2.752-1.05-1.007A.75.75 0 0 1 2.19.325Zm2.213 3.161-.058-.056-2.326 2.326 5.728 1.451 2.015-2.015a.029.029 0 0 0 0-.04l-3.549-3.55a.029.029 0 0 0-.04 0l-.767.767.035.034a.75.75 0 1 1-1.038 1.083Z"
      />
      <path d="M10.705 8.25a.255.255 0 0 0-.41 0l-1.06 1.633c-.419.604-.264 1.401.356 1.835a1.607 1.607 0 0 0 1.818 0c.62-.434.775-1.231.356-1.835l-1.06-1.633Z" />
    </g>
  ),
})

export const TwoPeopleSmallIcon = makeIcon({
  displayName: 'TwoPeopleSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.40002 2.5C2.40002 1.94772 2.84774 1.5 3.40002 1.5C3.95231 1.5 4.40002 1.94772 4.40002 2.5C4.40002 3.05228 3.95231 3.5 3.40002 3.5C2.84774 3.5 2.40002 3.05228 2.40002 2.5ZM3.40002 0C2.01931 0 0.900024 1.11929 0.900024 2.5C0.900024 3.88071 2.01931 5 3.40002 5C4.78074 5 5.90002 3.88071 5.90002 2.5C5.90002 1.11929 4.78074 0 3.40002 0ZM8 3.25C8 2.83579 8.33579 2.5 8.75 2.5C9.16421 2.5 9.5 2.83579 9.5 3.25C9.5 3.66421 9.16421 4 8.75 4C8.33579 4 8 3.66421 8 3.25ZM8.75 1C7.50736 1 6.5 2.00736 6.5 3.25C6.5 4.49264 7.50736 5.5 8.75 5.5C9.99264 5.5 11 4.49264 11 3.25C11 2.00736 9.99264 1 8.75 1ZM5.41976 7.26025C4.15984 6.94092 2.84016 6.94092 1.58024 7.26025C1.53305 7.27221 1.5 7.31469 1.5 7.36337V10.1366C1.5 10.1852 1.53305 10.2277 1.58024 10.2397C2.84016 10.559 4.15984 10.559 5.41976 10.2397C5.46695 10.2277 5.5 10.1852 5.5 10.1366V7.36337C5.5 7.31469 5.46695 7.27221 5.41976 7.26025ZM1.21171 5.80623C2.71349 5.42559 4.28651 5.42559 5.78829 5.80623C6.50092 5.98685 7 6.6282 7 7.36337V10.1366C7 10.8717 6.50092 11.5131 5.78829 11.6937C4.28651 12.0743 2.71349 12.0743 1.21171 11.6937C0.499077 11.5131 0 10.8717 0 10.1366V7.36337C0 6.6282 0.499077 5.98685 1.21171 5.80623ZM8.50001 6.25C8.08579 6.25 7.75 6.58578 7.75 6.99999C7.75 7.41421 8.08578 7.75 8.49999 7.75C8.49593 7.75 8.49898 7.75019 8.51139 7.75097L8.51141 7.75097L8.51143 7.75097C8.52966 7.75212 8.56804 7.75453 8.63366 7.75945C8.72787 7.76653 8.85333 7.77673 8.99944 7.78906C9.29123 7.8137 9.6587 7.84625 10.0092 7.87781C10.2864 7.90276 10.5 8.13564 10.5 8.41662V9.58338C10.5 9.86436 10.2864 10.0972 10.0092 10.1222C9.6587 10.1537 9.29123 10.1863 8.99944 10.2109C8.85333 10.2233 8.72787 10.2335 8.63366 10.2405C8.56802 10.2455 8.52964 10.2479 8.51142 10.249H8.5114C8.49898 10.2498 8.49593 10.25 8.5 10.25C8.08579 10.25 7.75 10.5858 7.75 11C7.75 11.4142 8.08579 11.75 8.5 11.75C8.59108 11.75 8.85619 11.7284 9.12562 11.7056C9.42161 11.6806 9.79238 11.6478 10.1437 11.6162C11.1967 11.5213 12 10.638 12 9.58338V8.41662C12 7.36198 11.1967 6.47865 10.1437 6.38385C9.79238 6.35222 9.42161 6.31937 9.12562 6.29438C8.85619 6.27164 8.59108 6.25 8.50001 6.25Z"
      />
    </g>
  ),
})

export const UserGroupSmallIcon = makeIcon({
  displayName: 'UserGroupSmallIcon',
  viewBox: 12,
  content: (
    <g clipPath="url(#clip0_2383_212)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.40002 0C2.01931 0 0.900024 1.11929 0.900024 2.5C0.900024 3.88071 2.01931 5 3.40002 5C4.78074 5 5.90002 3.88071 5.90002 2.5C5.90002 1.11929 4.78074 0 3.40002 0ZM2.40002 2.5C2.40002 1.94772 2.84774 1.5 3.40002 1.5C3.95231 1.5 4.40002 1.94772 4.40002 2.5C4.40002 3.05228 3.95231 3.5 3.40002 3.5C2.84774 3.5 2.40002 3.05228 2.40002 2.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.75 1C7.50736 1 6.5 2.00736 6.5 3.25C6.5 4.49264 7.50736 5.5 8.75 5.5C9.99264 5.5 11 4.49264 11 3.25C11 2.00736 9.99264 1 8.75 1ZM8 3.25C8 2.83579 8.33579 2.5 8.75 2.5C9.16421 2.5 9.5 2.83579 9.5 3.25C9.5 3.66421 9.16421 4 8.75 4C8.33579 4 8 3.66421 8 3.25Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.21171 5.80623C2.71349 5.42559 4.28651 5.42559 5.78829 5.80623C6.50092 5.98685 7 6.6282 7 7.36337V10.1366C7 10.8717 6.50092 11.5131 5.78829 11.6937C4.28651 12.0743 2.71349 12.0743 1.21171 11.6937C0.499077 11.5131 0 10.8717 0 10.1366V7.36337C0 6.6282 0.499077 5.98685 1.21171 5.80623ZM5.41976 7.26025C4.15984 6.94092 2.84016 6.94092 1.58024 7.26025C1.53305 7.27221 1.5 7.31469 1.5 7.36337V10.1366C1.5 10.1852 1.53305 10.2277 1.58024 10.2397C2.84016 10.559 4.15984 10.559 5.41976 10.2397C5.46695 10.2277 5.5 10.1852 5.5 10.1366V7.36337C5.5 7.31469 5.46695 7.27221 5.41976 7.26025Z"
      />
      <path d="M8.50001 6.25C8.08579 6.25 7.75 6.58578 7.75 6.99999C7.75 7.41421 8.08578 7.75 8.49999 7.75C8.49593 7.75 8.49898 7.75019 8.51139 7.75097C8.52962 7.75212 8.56804 7.75453 8.63366 7.75945C8.72787 7.76653 8.85333 7.77673 8.99944 7.78906C9.29123 7.8137 9.6587 7.84625 10.0092 7.87781C10.2864 7.90276 10.5 8.13564 10.5 8.41662V9.58338C10.5 9.86436 10.2864 10.0972 10.0092 10.1222C9.6587 10.1537 9.29123 10.1863 8.99944 10.2109C8.85333 10.2233 8.72787 10.2335 8.63366 10.2405C8.56802 10.2455 8.52964 10.2479 8.51142 10.249C8.499 10.2498 8.49593 10.25 8.5 10.25C8.08579 10.25 7.75 10.5858 7.75 11C7.75 11.4142 8.08579 11.75 8.5 11.75C8.59108 11.75 8.85619 11.7284 9.12562 11.7056C9.42161 11.6806 9.79238 11.6478 10.1437 11.6162C11.1967 11.5213 12 10.638 12 9.58338V8.41662C12 7.36198 11.1967 6.47865 10.1437 6.38385C9.79238 6.35222 9.42161 6.31937 9.12562 6.29438C8.85619 6.27164 8.59108 6.25 8.50001 6.25Z" />
    </g>
  ),
})
export const UserAddSmallIcon = makeIcon({
  displayName: 'UserAddSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0C4.48122 0 3.25 1.23122 3.25 2.75C3.25 4.26878 4.48122 5.5 6 5.5C7.51878 5.5 8.75 4.26878 8.75 2.75C8.75 1.23122 7.51878 0 6 0ZM4.75 2.75C4.75 2.05964 5.30964 1.5 6 1.5C6.69036 1.5 7.25 2.05964 7.25 2.75C7.25 3.44036 6.69036 4 6 4C5.30964 4 4.75 3.44036 4.75 2.75Z"
      />
      <path d="M2.7511 8.85698C3.03541 8.55716 3.51512 8.33013 4.14271 8.18535C4.75682 8.04369 5.42782 8 5.99999 8C6.4142 8 6.74999 7.66421 6.74999 7.25C6.74999 6.83579 6.4142 6.5 5.99999 6.5C5.36526 6.5 4.57074 6.54722 3.80554 6.72374C3.05382 6.89715 2.24042 7.21557 1.66267 7.82484C1.21265 8.2994 0.908275 8.95136 0.707035 9.49524C0.209805 10.8391 1.32292 12 2.55171 12H5.99999C6.4142 12 6.74999 11.6642 6.74999 11.25C6.74999 10.8358 6.4142 10.5 5.99999 10.5H2.55171C2.37431 10.5 2.23673 10.4204 2.16106 10.3242C2.092 10.2364 2.06984 10.1346 2.11383 10.0158C2.29315 9.53112 2.51241 9.10869 2.7511 8.85698Z" />
      <path d="M9.25 6.5C9.66421 6.5 10 6.83579 10 7.25V8.5H11.25C11.6642 8.5 12 8.83579 12 9.25C12 9.66421 11.6642 10 11.25 10H10V11.25C10 11.6642 9.66421 12 9.25 12C8.83579 12 8.5 11.6642 8.5 11.25V10H7.25C6.83579 10 6.5 9.66421 6.5 9.25C6.5 8.83579 6.83579 8.5 7.25 8.5H8.5V7.25C8.5 6.83579 8.83579 6.5 9.25 6.5Z" />
    </g>
  ),
})

export const DiscussionSmallIcon = makeIcon({
  displayName: 'DiscussionSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 2.25C4 1.83579 4.33579 1.5 4.75 1.5H9.75C10.1642 1.5 10.5 1.83579 10.5 2.25V5.25C10.5 5.66421 10.1642 6 9.75 6V4.5C9.75 3.25736 8.74264 2.25 7.5 2.25L4 2.25ZM2.5 2.25C2.5 1.00736 3.50736 0 4.75 0H9.75C10.9926 0 12 1.00736 12 2.25V5.25C12 6.49264 10.9926 7.5 9.75 7.5V7.67C9.75 8.91264 8.74264 9.92 7.5 9.92H6.52087C6.34226 9.92 6.16952 9.98374 6.03372 10.0998L4.01976 11.8202C3.81423 11.9958 3.53011 12.0472 3.27609 11.9548C3.02208 11.8623 2.83747 11.6403 2.79288 11.3737L2.54979 9.92H2.25C1.00736 9.92 0 8.91264 0 7.67V4.5C0 3.25736 1.00736 2.25 2.25 2.25L2.5 2.25ZM1.5 4.5C1.5 4.08579 1.83579 3.75 2.25 3.75H7.5C7.91421 3.75 8.25 4.08579 8.25 4.5V7.67C8.25 8.08421 7.91421 8.42 7.5 8.42H6.52087C5.98505 8.42 5.46681 8.61122 5.05941 8.95926L4.05364 9.81848L3.92451 9.0463C3.86407 8.68484 3.55126 8.42 3.18478 8.42H2.25C1.83579 8.42 1.5 8.08421 1.5 7.67V4.5Z"
      />
    </g>
  ),
})

export const DiscussionOpenSmallIcon = makeIcon({
  displayName: 'DiscussionOpenSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 1.5C2.05964 1.5 1.5 2.05964 1.5 2.75V7.22054C1.5 7.91089 2.05964 8.47054 2.75 8.47054H3.375C3.71779 8.47054 4.01696 8.70295 4.10171 9.0351L4.33731 9.95837L5.65388 8.94049C6.04795 8.63582 6.53198 8.47054 7.03009 8.47054H9.25C9.94036 8.47054 10.5 7.91089 10.5 7.22054V2.75C10.5 2.05964 9.94036 1.5 9.25 1.5H2.75ZM0 2.75C0 1.23122 1.23122 0 2.75 0H9.25C10.7688 0 12 1.23122 12 2.75V7.22054C12 8.73932 10.7688 9.97054 9.25 9.97054H7.03009C6.86405 9.97054 6.70271 10.0256 6.57135 10.1272L4.35159 11.8433C4.15178 11.9978 3.88764 12.0414 3.64883 11.9592C3.41001 11.877 3.22859 11.6802 3.16614 11.4354L2.79235 9.97054H2.75C1.23122 9.97054 0 8.73932 0 7.22054V2.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 3.75C3.25 3.33579 3.58579 3 4 3H8C8.41421 3 8.75 3.33579 8.75 3.75C8.75 4.16421 8.41421 4.5 8 4.5H4C3.58579 4.5 3.25 4.16421 3.25 3.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.25 6.25C3.25 5.83579 3.58579 5.5 4 5.5H6.5C6.91421 5.5 7.25 5.83579 7.25 6.25C7.25 6.66421 6.91421 7 6.5 7H4C3.58579 7 3.25 6.66421 3.25 6.25Z"
      />
    </g>
  ),
})

export const DiscussionClosedSmallIcon = makeIcon({
  displayName: 'DiscussionClosedSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 1.5C2.05964 1.5 1.5 2.05964 1.5 2.75V7.22054C1.5 7.91089 2.05964 8.47054 2.75 8.47054H3.375C3.71779 8.47054 4.01696 8.70295 4.10171 9.0351L4.33731 9.95837L5.65388 8.94049C6.04795 8.63582 6.53198 8.47054 7.03009 8.47054H9.25C9.94036 8.47054 10.5 7.91089 10.5 7.22054V6.5C10.5 6.08579 10.8358 5.75 11.25 5.75C11.6642 5.75 12 6.08579 12 6.5V7.22054C12 8.73932 10.7688 9.97054 9.25 9.97054H7.03009C6.86405 9.97054 6.70271 10.0256 6.57135 10.1272L4.35159 11.8433C4.15178 11.9978 3.88764 12.0414 3.64883 11.9592C3.41001 11.877 3.22859 11.6802 3.16614 11.4354L2.79235 9.97054H2.75C1.23122 9.97054 0 8.73932 0 7.22054V2.75C0 1.23122 1.23122 0 2.75 0H6.51786C6.93207 0 7.26786 0.335786 7.26786 0.75C7.26786 1.16421 6.93207 1.5 6.51786 1.5H2.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5856 2.53151C10.8444 2.85495 10.7919 3.32692 10.4685 3.58568L6.71849 6.58568C6.562 6.71088 6.36191 6.76823 6.16285 6.74495C5.96379 6.72167 5.78234 6.61969 5.65895 6.46176L4.40895 4.86176C4.15395 4.53535 4.21183 4.06402 4.53824 3.80901C4.86465 3.554 5.33598 3.61188 5.59099 3.93829L6.3739 4.94042L9.53145 2.41438C9.8549 2.15562 10.3269 2.20806 10.5856 2.53151Z"
      />
    </g>
  ),
})

export const DiscussionDecisionSmallIcon = makeIcon({
  displayName: 'DiscussionDecisionSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 1.5C2.05967 1.5 1.5 2.05968 1.5 2.75006V7.22047C1.5 7.91086 2.05967 8.47054 2.75 8.47054H3.375C3.71779 8.47054 4.01696 8.70295 4.10171 9.0351L4.33731 9.95837L5.65388 8.94049C6.04795 8.63582 6.53198 8.47054 7.03009 8.47054H9.25C9.94036 8.47054 10.5 7.91089 10.5 7.22054V7C10.5 6.58579 10.8358 6.25 11.25 6.25C11.6642 6.25 12 6.58579 12 7V7.22054C12 8.73932 10.7688 9.97054 9.25 9.97054H7.03009C6.86405 9.97054 6.70271 10.0256 6.57135 10.1272L4.35159 11.8433C4.15178 11.9978 3.88764 12.0414 3.64883 11.9592C3.41001 11.877 3.22859 11.6802 3.16614 11.4354L2.79235 9.97054H2.75C1.23119 9.97054 0 8.73922 0 7.22047V2.75006C0 1.23131 1.23119 0 2.75 0H4.5C4.91421 0 5.25 0.335786 5.25 0.75C5.25 1.16421 4.91421 1.5 4.5 1.5H2.75Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.57453 0.403996C9.28835 0.117816 8.82673 0.110309 8.53139 0.387034L6.07549 2.68818C5.78364 2.48984 5.38293 2.52002 5.12421 2.77874C4.83132 3.07164 4.83132 3.54651 5.12421 3.8394L5.53671 4.2519C5.53711 4.2523 5.53751 4.2527 5.53791 4.2531L6.11067 4.82586L4.98637 5.95016C4.69347 6.24305 4.69347 6.71792 4.98637 7.01082C5.27926 7.30371 5.75413 7.30371 6.04703 7.01082L7.17133 5.88652L7.744 6.45919C7.7444 6.45959 7.7448 6.45999 7.7452 6.46039L8.15759 6.87278C8.45048 7.16567 8.92535 7.16567 9.21825 6.87278C9.47693 6.6141 9.50714 6.21347 9.30889 5.92163L11.6101 3.46571C11.8868 3.17037 11.8793 2.70875 11.5931 2.42257L9.57453 0.403996ZM8.25679 4.85067L10.0191 2.96987L9.02723 1.97802L7.14643 3.7403L8.25679 4.85067Z"
      />
    </g>
  ),
})

export const ChannelSmallIcon = makeIcon({
  displayName: 'ChannelSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 2.25C0.5 1.00736 1.50736 0 2.75 0H9.25C10.4926 0 11.5 1.00736 11.5 2.25V9.75C11.5 10.9926 10.4926 12 9.25 12H4.75H3.25H2.75C1.50736 12 0.5 10.9926 0.5 9.75V2.25ZM9.25 10.5H4.75V1.5H9.25C9.66421 1.5 10 1.83579 10 2.25V9.75C10 10.1642 9.66421 10.5 9.25 10.5ZM2.75 1.5H3.25V10.5H2.75C2.33579 10.5 2 10.1642 2 9.75V2.25C2 1.83579 2.33579 1.5 2.75 1.5ZM6.5 3.25C6.08579 3.25 5.75 3.58579 5.75 4C5.75 4.41421 6.08579 4.75 6.5 4.75H8C8.41421 4.75 8.75 4.41421 8.75 4C8.75 3.58579 8.41421 3.25 8 3.25L6.5 3.25Z"
      />
    </g>
  ),
})

export const LockSmallIcon = makeIcon({
  displayName: 'LockSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0C4.34315 0 3 1.34315 3 3V4.03581C2.82931 4.06737 2.67216 4.09902 2.53048 4.1293C1.67132 4.31293 1.125 5.07765 1.125 5.89953V9.77803C1.125 10.659 1.74271 11.4369 2.63178 11.6C3.52782 11.7643 4.97933 12 6 12C7.02067 12 8.47218 11.7643 9.36822 11.6C10.2573 11.4369 10.875 10.659 10.875 9.77803V5.89953C10.875 5.07765 10.3287 4.31293 9.46952 4.1293C9.32784 4.09902 9.17069 4.06737 9 4.03581V3C9 1.34315 7.65685 0 6 0ZM7.5 3.82446V3C7.5 2.17157 6.82843 1.5 6 1.5C5.17157 1.5 4.5 2.17157 4.5 3V3.82446C4.96816 3.77916 5.47382 3.75 6 3.75C6.52618 3.75 7.03184 3.77916 7.5 3.82446ZM6 5.25C4.72472 5.25 3.56906 5.4412 2.844 5.59617C2.73148 5.62022 2.625 5.7278 2.625 5.89953V9.77803C2.625 9.95798 2.74786 10.0962 2.90235 10.1246C3.80724 10.2905 5.13341 10.5 6 10.5C6.86659 10.5 8.19276 10.2905 9.09765 10.1246C9.25214 10.0962 9.375 9.95798 9.375 9.77803V5.89953C9.375 5.7278 9.26852 5.62022 9.156 5.59617C8.43094 5.4412 7.27528 5.25 6 5.25ZM6.75 8.0625C6.75 8.47671 6.41421 8.8125 6 8.8125C5.58579 8.8125 5.25 8.47671 5.25 8.0625C5.25 7.64829 5.58579 7.3125 6 7.3125C6.41421 7.3125 6.75 7.64829 6.75 8.0625Z"
      />
    </g>
  ),
})

export const SettingsSmallIcon = makeIcon({
  displayName: 'SettingsSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.161 4a.998.998 0 000-1.5h3.089a.75.75 0 010 1.5H8.161zM6.84 4H.75a.75.75 0 010-1.5h6.089a.998.998 0 000 1.5z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 3.25a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-2.5 1a1 1 0 100-2 1 1 0 000 2zM4.911 10a.998.998 0 000-1.5h6.339a.75.75 0 010 1.5H4.911zM3.59 10H.75a.75.75 0 010-1.5h2.839a.998.998 0 000 1.5z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 9.25a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-2.5 1a1 1 0 100-2 1 1 0 000 2z"
        fill="currentColor"
      />
    </g>
  ),
})

export const ChannelAddSmallIcon = makeIcon({
  displayName: 'ChannelAddSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 2.25C0.5 1.00736 1.50736 0 2.75 0H9.25C10.4926 0 11.5 1.00736 11.5 2.25V5C11.5 5.41421 11.1642 5.75 10.75 5.75C10.3358 5.75 10 5.41421 10 5V2.25C10 1.83579 9.66421 1.5 9.25 1.5H4.75V10.5H5.5C5.91421 10.5 6.25 10.8358 6.25 11.25C6.25 11.6642 5.91421 12 5.5 12H2.75C1.50736 12 0.5 10.9926 0.5 9.75V2.25ZM2.75 1.5H3.25V10.5H2.75C2.33579 10.5 2 10.1642 2 9.75V2.25C2 1.83579 2.33579 1.5 2.75 1.5Z"
      />
      <path d="M6.5 3.25C6.08579 3.25 5.75 3.58579 5.75 4C5.75 4.41421 6.08579 4.75 6.5 4.75H8C8.41421 4.75 8.75 4.41421 8.75 4C8.75 3.58579 8.41421 3.25 8 3.25L6.5 3.25Z" />
      <path d="M10 7.25C10 6.83579 9.66421 6.5 9.25 6.5C8.83579 6.5 8.5 6.83579 8.5 7.25V8.5H7.25C6.83579 8.5 6.5 8.83579 6.5 9.25C6.5 9.66421 6.83579 10 7.25 10H8.5V11.25C8.5 11.6642 8.83579 12 9.25 12C9.66421 12 10 11.6642 10 11.25V10H11.25C11.6642 10 12 9.66421 12 9.25C12 8.83579 11.6642 8.5 11.25 8.5H10V7.25Z" />
    </g>
  ),
})

export const SortingSmallIcon = makeIcon({
  displayName: 'SortingSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <g
        clipPath="url(#clip0_2547_475)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
      >
        <path d="M3.192 3a.75.75 0 01.75.75v5.657l1.172-1.192a.735.735 0 011.052 0c.29.296.29.774 0 1.07L3.799 11.69a.735.735 0 01-.607.31.735.735 0 01-.607-.31L.218 9.285a.765.765 0 010-1.07.735.735 0 011.052 0l1.172 1.192V3.75a.75.75 0 01.75-.75zM11.724 3.785a.735.735 0 01-1.052 0L9.5 2.593V8.25a.75.75 0 11-1.5 0V2.593L6.828 3.785a.735.735 0 01-1.052 0 .765.765 0 010-1.07L8.143.31a.735.735 0 01.607-.31.735.735 0 01.607.31l2.367 2.406c.29.296.29.774 0 1.07z" />
      </g>
      <defs>
        <clipPath id="clip0_2547_475">
          <path fill="#fff" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const FilterSmallIcon = makeIcon({
  displayName: 'FilterSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <g clipPath="url(#clip0_2547_320)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="currentColor"
          d="M.47.47A.75.75 0 011 .25h10a.75.75 0 01.75.75v1.818a.75.75 0 01-.19.498L8.115 7.194v2.442a.75.75 0 01-.467.695L4.92 11.444a.75.75 0 01-1.034-.694V7.194L.44 3.316a.75.75 0 01-.189-.498V1A.75.75 0 01.47.47zm1.28 1.28v.783l3.447 3.878a.75.75 0 01.19.498v2.725l1.227-.502V6.91a.75.75 0 01.19-.498l3.446-3.878V1.75h-8.5z"
        />
      </g>
      <defs>
        <clipPath id="clip0_2547_320">
          <path fill="#fff" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const ExpandTwoCornersSmallIcon = makeIcon({
  displayName: 'ExpandTwoCornersSmall',
  viewBox: 12,
  content: (
    <g>
      <path
        d="M11.25 5.25C11.6642 5.25 12 4.91421 12 4.5V0.75C12 0.335786 11.6642 0 11.25 0H7.5C7.08579 0 6.75 0.335786 6.75 0.75C6.75 1.16421 7.08579 1.5 7.5 1.5H9.43922L6.96967 3.96955C6.67677 4.26244 6.67677 4.73732 6.96967 5.03021C7.26256 5.32311 7.73743 5.32311 8.03033 5.03021L10.5 2.56054V4.5C10.5 4.91421 10.8358 5.25 11.25 5.25Z"
        fill="currentColor"
      />
      <path
        d="M0.749992 6.74988C0.335779 6.74988 -7.62939e-06 7.08566 -7.62939e-06 7.49988V11.2499C-7.62939e-06 11.6641 0.335779 11.9999 0.749992 11.9999H4.49999C4.91421 11.9999 5.24999 11.6641 5.24999 11.2499C5.24999 10.8357 4.91421 10.4999 4.49999 10.4999H2.56077L5.03033 8.03033C5.32322 7.73743 5.32322 7.26256 5.03033 6.96967C4.73743 6.67677 4.26256 6.67677 3.96967 6.96966L1.49999 9.43933V7.49988C1.49999 7.08566 1.16421 6.74988 0.749992 6.74988Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const ReduceTwoCornersSmallIcon = makeIcon({
  displayName: 'ReduceTwoCornersSmall',
  viewBox: 12,
  content: (
    <g>
      <path
        d="M7.5 0C7.08578 0 6.75 0.335786 6.75 0.75V4.5C6.75 4.91421 7.08578 5.25 7.5 5.25H11.25C11.6642 5.25 12 4.91421 12 4.5C12 4.08579 11.6642 3.75 11.25 3.75H9.31077L11.7803 1.28045C12.0732 0.987555 12.0732 0.512681 11.7803 0.219788C11.4874 -0.0731059 11.0126 -0.0731064 10.7197 0.219786L8.25 2.68946V0.75C8.25 0.335786 7.91421 0 7.5 0Z"
        fill="currentColor"
      />
      <path
        d="M4.5 11.9999C4.91422 11.9999 5.25 11.6641 5.25 11.2499V7.49988C5.25 7.08566 4.91422 6.74988 4.5 6.74988H0.750004C0.335791 6.74988 3.8147e-06 7.08566 3.8147e-06 7.49988C3.8147e-06 7.91409 0.335791 8.24988 0.750004 8.24988H2.68923L0.21967 10.7194C-0.0732231 11.0123 -0.0732231 11.4872 0.219669 11.7801C0.512562 12.073 0.987436 12.073 1.28033 11.7801L3.75 9.31042V11.2499C3.75 11.6641 4.08579 11.9999 4.5 11.9999Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const LinkSmallIcon = makeIcon({
  displayName: 'LinkSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.28433 7.6124C4.42718 7.74957 4.61633 7.82809 4.81433 7.8324C5.01275 7.83009 5.20261 7.75128 5.34433 7.6124C5.41509 7.54345 5.47132 7.46104 5.50972 7.37001C5.54812 7.27898 5.5679 7.18119 5.5679 7.0824C5.5679 6.9836 5.54812 6.88581 5.50972 6.79479C5.47132 6.70376 5.41509 6.62134 5.34433 6.5524C5.01702 6.22271 4.83333 5.77697 4.83333 5.3124C4.83333 4.84782 5.01702 4.40209 5.34433 4.0724L7.47433 1.9124C7.80911 1.58322 8.25982 1.39875 8.72933 1.39875C9.19884 1.39875 9.64955 1.58322 9.98433 1.9124C10.1525 2.07636 10.2861 2.27231 10.3773 2.4887C10.4685 2.7051 10.5155 2.93756 10.5155 3.1724C10.5155 3.40724 10.4685 3.6397 10.3773 3.85609C10.2861 4.07249 10.1525 4.26844 9.98433 4.4324L9.57433 4.8024C9.50357 4.87134 9.44734 4.95376 9.40894 5.04479C9.37054 5.13581 9.35076 5.2336 9.35076 5.3324C9.35076 5.43119 9.37054 5.52898 9.40894 5.62001C9.44734 5.71104 9.50357 5.79345 9.57433 5.8624C9.71496 6.00285 9.90558 6.08174 10.1043 6.08174C10.3031 6.08174 10.4937 6.00285 10.6343 5.8624L10.9843 5.5124C11.5925 4.90145 11.934 4.07447 11.934 3.2124C11.934 2.35032 11.5925 1.52334 10.9843 0.912398C10.3658 0.326527 9.54627 0 8.69433 0C7.84239 0 7.02285 0.326527 6.40433 0.912398L4.28433 3.0124C3.67854 3.62462 3.33875 4.45112 3.33875 5.3124C3.33875 6.17368 3.67854 7.00018 4.28433 7.6124ZM1.44385 11.3643C1.98247 11.7244 2.61641 11.9152 3.26429 11.9124C3.69479 11.9064 4.1198 11.8148 4.51464 11.6432C4.90947 11.4715 5.26626 11.2231 5.56429 10.9124L7.68429 8.81238C8.29008 8.20016 8.62988 7.37366 8.62988 6.51238C8.62988 5.6511 8.29008 4.8246 7.68429 4.21238C7.54366 4.07193 7.35304 3.99304 7.15429 3.99304C6.95554 3.99304 6.76491 4.07193 6.62429 4.21238C6.55353 4.28133 6.4973 4.36374 6.4589 4.45477C6.4205 4.5458 6.40072 4.64359 6.40072 4.74238C6.40072 4.84118 6.4205 4.93897 6.4589 5.02999C6.4973 5.12102 6.55353 5.20344 6.62429 5.27238C6.9516 5.60207 7.13529 6.04781 7.13529 6.51238C7.13529 6.97696 6.9516 7.42269 6.62429 7.75238L4.45429 9.91238C4.1214 10.2297 3.67917 10.4067 3.21929 10.4067C2.75941 10.4067 2.31718 10.2297 1.98429 9.91238C1.81661 9.74499 1.68489 9.54512 1.59719 9.32502C1.50949 9.10491 1.46767 8.86922 1.47429 8.63238C1.47328 8.40376 1.51787 8.17722 1.60544 7.96603C1.693 7.75483 1.8218 7.56322 1.98429 7.40238L2.39429 7.04238C2.46505 6.97344 2.52128 6.89102 2.55968 6.79999C2.59808 6.70897 2.61786 6.61118 2.61786 6.51238C2.61786 6.41359 2.59808 6.3158 2.55968 6.22477C2.52128 6.13374 2.46505 6.05133 2.39429 5.98238C2.25366 5.84193 2.06304 5.76304 1.86429 5.76304C1.66554 5.76304 1.47491 5.84193 1.33429 5.98238L0.984289 6.33238C0.519802 6.78405 0.200908 7.36423 0.0685478 7.99845C-0.0638128 8.63266 -0.00359902 9.29196 0.241459 9.89171C0.486516 10.4915 0.905233 11.0043 1.44385 11.3643Z"
      />
    </g>
  ),
})

export const InviteSmallIcon = makeIcon({
  displayName: 'InviteSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0C4.48122 0 3.25 1.23122 3.25 2.75C3.25 4.26878 4.48122 5.5 6 5.5C7.51878 5.5 8.75 4.26878 8.75 2.75C8.75 1.23122 7.51878 0 6 0ZM4.75 2.75C4.75 2.05964 5.30964 1.5 6 1.5C6.69036 1.5 7.25 2.05964 7.25 2.75C7.25 3.44036 6.69036 4 6 4C5.30964 4 4.75 3.44036 4.75 2.75Z"
        fill="currentColor"
      />
      <path
        d="M2.7511 8.85698C3.03541 8.55716 3.51512 8.33013 4.14271 8.18535C4.75682 8.04369 5.42782 8 5.99999 8C6.4142 8 6.74999 7.66421 6.74999 7.25C6.74999 6.83579 6.4142 6.5 5.99999 6.5C5.36526 6.5 4.57074 6.54722 3.80554 6.72374C3.05382 6.89715 2.24042 7.21557 1.66267 7.82484C1.21265 8.2994 0.908275 8.95136 0.707035 9.49524C0.209805 10.8391 1.32292 12 2.55171 12H5.99999C6.4142 12 6.74999 11.6642 6.74999 11.25C6.74999 10.8358 6.4142 10.5 5.99999 10.5H2.55171C2.37431 10.5 2.23673 10.4204 2.16106 10.3242C2.092 10.2364 2.06984 10.1346 2.11383 10.0158C2.29315 9.53112 2.51241 9.10869 2.7511 8.85698Z"
        fill="currentColor"
      />
      <path
        d="M9.25 6.5C9.66421 6.5 10 6.83579 10 7.25V8.5H11.25C11.6642 8.5 12 8.83579 12 9.25C12 9.66421 11.6642 10 11.25 10H10V11.25C10 11.6642 9.66421 12 9.25 12C8.83579 12 8.5 11.6642 8.5 11.25V10H7.25C6.83579 10 6.5 9.66421 6.5 9.25C6.5 8.83579 6.83579 8.5 7.25 8.5H8.5V7.25C8.5 6.83579 8.83579 6.5 9.25 6.5Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const CollectionTableSmallIcon = makeIcon({
  displayName: 'CollectionTableSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.25 1.75V1.5A1.5 1.5 0 0 1 1.75 0h8.5a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-8.5a1.5 1.5 0 0 1-1.5-1.5V1.75Zm10 8.75h-3.5V7.25h3.5v3.25Zm0-4.75h-3.5V2.5h3.5v3.25Zm-5 0V2.5h-3.5v3.25h3.5Zm-3.5 1.5v3.25h3.5V7.25h-3.5Z"
      fill="currentColor"
    />
  ),
})

export const CollectionBoardSmallIcon = makeIcon({
  displayName: 'CollectionBoardSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.75 2.5h3.5v5h-3.5v-5Zm-1.5 0h-3.5v8h3.5v-8Zm1.5 8V9h3.5a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5h-8.5a1.5 1.5 0 0 0-1.5 1.5v9a1.5 1.5 0 0 0 1.5 1.5h3.5a1.5 1.5 0 0 0 1.5-1.5Z"
      fill="currentColor"
    />
  ),
})

export const RequestVerificationSmallIcon = makeIcon({
  displayName: 'RequestVerificationSmallIcon',
  viewBox: 12,
  content: (
    <>
      <path d="M5.295.041a6 6 0 1 1 0 11.918.75.75 0 0 1 .175-1.49 4.564 4.564 0 0 0 .664.029 4.5 4.5 0 1 0-.664-8.967.75.75 0 1 1-.175-1.49ZM3.338 1.412a.75.75 0 0 1-.124 1.054c-.278.219-.529.47-.748.748a.75.75 0 1 1-1.178-.93c.292-.369.627-.704.997-.996a.75.75 0 0 1 1.053.124ZM.873 4.638a.75.75 0 0 1 .658.832 4.555 4.555 0 0 0 0 1.06.75.75 0 1 1-1.49.175 6.055 6.055 0 0 1 0-1.41.75.75 0 0 1 .832-.657ZM1.412 8.662a.75.75 0 0 1 1.054.124c.219.278.47.529.748.748a.75.75 0 1 1-.93 1.178 6.034 6.034 0 0 1-.996-.997.75.75 0 0 1 .124-1.053Z" />
      <path d="M9.01 5.53a.75.75 0 0 0-1.061-1.06l-2.49 2.49-.929-.93a.75.75 0 0 0-1.06 1.061l1.459 1.46a.75.75 0 0 0 1.06 0l3.02-3.02Z" />
    </>
  ),
})

export const WarningSmallIcon = makeIcon({
  displayName: 'WarningSmallIcon',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5ZM6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 3C6.41421 3 6.75 3.29628 6.75 3.66176V6.08824C6.75 6.45372 6.41421 6.75 6 6.75C5.58579 6.75 5.25 6.45372 5.25 6.08824V3.66176C5.25 3.29628 5.58579 3 6 3Z"
      />
      <path d="M6.75 8.25C6.75 8.66421 6.41421 9 6 9C5.58579 9 5.25 8.66421 5.25 8.25C5.25 7.83579 5.58579 7.5 6 7.5C6.41421 7.5 6.75 7.83579 6.75 8.25Z" />
    </>
  ),
})

export const DuplicateSmallIcon = makeIcon({
  displayName: 'DuplicateSmallIcon',
  viewBox: 12,
  content: (
    <>
      <path
        d="M0 5.25C0 4.2835 0.783502 3.5 1.75 3.5H6.75C7.7165 3.5 8.5 4.2835 8.5 5.25V10.25C8.5 11.2165 7.7165 12 6.75 12H1.75C0.783502 12 0 11.2165 0 10.25V5.25ZM1.75 5C1.61193 5 1.5 5.11193 1.5 5.25V10.25C1.5 10.3881 1.61193 10.5 1.75 10.5H6.75C6.88807 10.5 7 10.3881 7 10.25V5.25C7 5.11193 6.88807 5 6.75 5H1.75Z"
        fill="currentColor"
      />
      <path
        d="M3.5 1.75C3.5 0.783502 4.2835 0 5.25 0H10.25C11.2165 0 12 0.783502 12 1.75V6.75C12 7.7165 11.2165 8.5 10.25 8.5H10C9.58579 8.5 9.25 8.16421 9.25 7.75C9.25 7.33579 9.58579 7 10 7H10.25C10.3881 7 10.5 6.88807 10.5 6.75V1.75C10.5 1.61193 10.3881 1.5 10.25 1.5H5.25C5.11193 1.5 5 1.61193 5 1.75V2C5 2.41421 4.66421 2.75 4.25 2.75C3.83579 2.75 3.5 2.41421 3.5 2V1.75Z"
        fill="currentColor"
      />
    </>
  ),
})

export const CircleDashedSmallIcon = makeIcon({
  displayName: 'CircleDashedSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      d="M5.295.041a6.055 6.055 0 0 1 1.41 0 .75.75 0 0 1-.175 1.49 4.555 4.555 0 0 0-1.06 0A.75.75 0 1 1 5.295.04ZM3.338 1.412a.75.75 0 0 1-.124 1.054c-.278.219-.529.47-.748.748a.75.75 0 1 1-1.178-.93c.292-.369.627-.704.997-.996a.75.75 0 0 1 1.053.124Zm5.324 0a.75.75 0 0 1 1.053-.124c.37.292.705.627.997.997a.75.75 0 0 1-1.178.93c-.219-.279-.47-.53-.748-.75a.75.75 0 0 1-.124-1.053ZM.873 4.638a.75.75 0 0 1 .658.832 4.555 4.555 0 0 0 0 1.06.75.75 0 1 1-1.49.175 6.055 6.055 0 0 1 0-1.41.75.75 0 0 1 .832-.657Zm10.254 0a.75.75 0 0 1 .832.657 6.058 6.058 0 0 1 0 1.41.75.75 0 0 1-1.49-.175 4.564 4.564 0 0 0 0-1.06.75.75 0 0 1 .658-.832ZM1.412 8.662a.75.75 0 0 1 1.054.124c.219.278.47.529.748.748a.75.75 0 1 1-.93 1.178 6.034 6.034 0 0 1-.996-.997.75.75 0 0 1 .124-1.053Zm9.176 0a.75.75 0 0 1 .124 1.053c-.292.37-.627.705-.997.997a.75.75 0 0 1-.93-1.178c.279-.219.53-.47.75-.748a.75.75 0 0 1 1.053-.124Zm-5.95 2.465a.75.75 0 0 1 .832-.658 4.564 4.564 0 0 0 1.06 0 .75.75 0 1 1 .175 1.49 6.058 6.058 0 0 1-1.41 0 .75.75 0 0 1-.657-.832Z"
      clipRule="evenodd"
    />
  ),
})

export const CirclularArrowsSmallIcon = makeIcon({
  displayName: 'CirclularArrowsSmallIcon',
  viewBox: 12,
  content: (
    <path d="M10.021 7.3a4.14 4.14 0 0 1-7.69.929H4.12a.75.75 0 1 0 0-1.5H.75a.75.75 0 0 0-.75.75v3.369a.75.75 0 0 0 1.5 0v-1.14a5.641 5.641 0 0 0 9.979-2.052.75.75 0 0 0-1.457-.356ZM1.928 4.701a4.141 4.141 0 0 1 7.69-.928H7.831a.75.75 0 1 0 0 1.5H11.2a.75.75 0 0 0 .75-.75V1.154a.75.75 0 0 0-1.5 0v1.139A5.641 5.641 0 0 0 .472 4.345a.75.75 0 0 0 1.456.356Z" />
  ),
})

export const ClockSmallIcon = makeIcon({
  displayName: 'ClockSmallIcon',
  viewBox: 12,
  content: (
    <>
      <path d="M6.5 4A.75.75 0 1 0 5 4v2.25c0 .414.336.75.75.75H8a.75.75 0 0 0 0-1.5H6.5V4Z" />
      <path
        fillRule="evenodd"
        d="M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0Zm-1.5 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
        clipRule="evenodd"
      />
    </>
  ),
})

export const SuccessCircledSmallIcon = makeIcon({
  displayName: 'SuccessCircledSmallIcon',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        d="M6 10.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M8.8 4.22a.75.75 0 0 1 0 1.06L5.78 8.3a.75.75 0 0 1-1.06 0L3.26 6.841a.75.75 0 0 1 1.061-1.06l.929.928 2.49-2.49a.75.75 0 0 1 1.06 0Z"
        clipRule="evenodd"
      />
    </>
  ),
})

export const ChevronRightSmallIcon = makeIcon({
  displayName: 'ChevronRightSmallIcon',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.46967 1.46967C3.76256 1.17678 4.23744 1.17678 4.53033 1.46967L8.53033 5.46967C8.82322 5.76256 8.82322 6.23744 8.53033 6.53033L4.53033 10.5303C4.23744 10.8232 3.76256 10.8232 3.46967 10.5303C3.17678 10.2374 3.17678 9.76256 3.46967 9.46967L6.93934 6L3.46967 2.53033C3.17678 2.23744 3.17678 1.76256 3.46967 1.46967Z"
      />
    </>
  ),
})

export const ChevronLeftSmallIcon = makeIcon({
  displayName: 'ChevronLeftSmallIcon',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.53033 1.46967C8.23744 1.17678 7.76256 1.17678 7.46967 1.46967L3.46967 5.46967C3.17678 5.76256 3.17678 6.23744 3.46967 6.53033L7.46967 10.5303C7.76256 10.8232 8.23744 10.8232 8.53033 10.5303C8.82322 10.2374 8.82322 9.76256 8.53033 9.46967L5.06066 6L8.53033 2.53033C8.82322 2.23744 8.82322 1.76256 8.53033 1.46967Z"
      />
    </>
  ),
})

export const ChevronDownSmallIcon = makeIcon({
  displayName: 'ChevronDownSmallIcon',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5303 3.46967C10.8232 3.76256 10.8232 4.23744 10.5303 4.53033L6.53033 8.53033C6.23744 8.82322 5.76256 8.82322 5.46967 8.53033L1.46967 4.53033C1.17678 4.23744 1.17678 3.76256 1.46967 3.46967C1.76256 3.17678 2.23744 3.17678 2.53033 3.46967L6 6.93934L9.46967 3.46967C9.76256 3.17678 10.2374 3.17678 10.5303 3.46967Z"
      />
    </>
  ),
})

export const ChevronUpSmallIcon = makeIcon({
  displayName: 'ChevronUpSmallIcon',
  viewBox: 12,
  content: (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.46967 8.53033C1.17678 8.23744 1.17678 7.76256 1.46967 7.46967L5.46967 3.46967C5.76256 3.17678 6.23744 3.17678 6.53033 3.46967L10.5303 7.46967C10.8232 7.76256 10.8232 8.23744 10.5303 8.53033C10.2374 8.82322 9.76256 8.82322 9.46967 8.53033L6 5.06066L2.53033 8.53033C2.23744 8.82322 1.76256 8.82322 1.46967 8.53033Z"
      />
    </>
  ),
})

export const EmojiSmallIcon = makeIcon({
  displayName: 'EmojiSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path d="M4.5 6C4.91421 6 5.25 5.66421 5.25 5.25C5.25 4.83579 4.91421 4.5 4.5 4.5C4.08579 4.5 3.75 4.83579 3.75 5.25C3.75 5.66421 4.08579 6 4.5 6Z" />
      <path d="M7.5 6C7.91421 6 8.25 5.66421 8.25 5.25C8.25 4.83579 7.91421 4.5 7.5 4.5C7.08579 4.5 6.75 4.83579 6.75 5.25C6.75 5.66421 7.08579 6 7.5 6Z" />
      <path d="M7.5 7.125C7.5 7.95343 6.82843 8.625 6 8.625C5.17157 8.625 4.5 7.95343 4.5 7.125H7.5Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM10.5 6C10.5 8.48528 8.48528 10.5 6 10.5C3.51472 10.5 1.5 8.48528 1.5 6C1.5 3.51472 3.51472 1.5 6 1.5C8.48528 1.5 10.5 3.51472 10.5 6Z"
      />
    </g>
  ),
})

export const AddReactionSmallIcon = makeIcon({
  displayName: 'AddReactionSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path d="M10.25 0.75C10.25 0.335786 9.91421 0 9.5 0C9.08579 0 8.75 0.335786 8.75 0.75V1.75H7.75C7.33579 1.75 7 2.08579 7 2.5C7 2.91421 7.33579 3.25 7.75 3.25H8.75V4.25C8.75 4.66421 9.08579 5 9.5 5C9.91421 5 10.25 4.66421 10.25 4.25V3.25H11.25C11.6642 3.25 12 2.91421 12 2.5C12 2.08579 11.6642 1.75 11.25 1.75H10.25V0.75Z" />
      <path d="M4.5 6C4.91421 6 5.25 5.66421 5.25 5.25C5.25 4.83579 4.91421 4.5 4.5 4.5C4.08579 4.5 3.75 4.83579 3.75 5.25C3.75 5.66421 4.08579 6 4.5 6Z" />
      <path d="M7.5 6C7.91421 6 8.25 5.66421 8.25 5.25C8.25 4.83579 7.91421 4.5 7.5 4.5C7.08579 4.5 6.75 4.83579 6.75 5.25C6.75 5.66421 7.08579 6 7.5 6Z" />
      <path d="M7.5 7.125C7.5 7.95343 6.82843 8.625 6 8.625C5.17157 8.625 4.5 7.95343 4.5 7.125H7.5Z" />
      <path d="M5.05974 1.59817C5.46492 1.51211 5.72361 1.11389 5.63756 0.708715C5.5515 0.30354 5.15328 0.0448423 4.7481 0.130899C2.03546 0.707044 0 3.11493 0 5.99995C0 9.31365 2.68629 11.9999 6 11.9999C9.01879 11.9999 11.5157 9.77125 11.9374 6.86928C11.9969 6.45937 11.7129 6.07879 11.303 6.01924C10.8931 5.95968 10.5125 6.24369 10.453 6.6536C10.1369 8.82886 8.26295 10.4999 6 10.4999C3.51472 10.4999 1.5 8.48523 1.5 5.99995C1.5 3.83776 3.02567 2.03019 5.05974 1.59817Z" />
    </g>
  ),
})

export const CollectionSmallIcon = makeIcon({
  displayName: 'CollectionSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5 1a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Zm-2 3.25a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1-.75-.75Zm9 3.25h-9v2h9v-2ZM1.5 6A1.5 1.5 0 0 0 0 7.5v2A1.5 1.5 0 0 0 1.5 11h9A1.5 1.5 0 0 0 12 9.5v-2A1.5 1.5 0 0 0 10.5 6h-9Z"
    />
  ),
})

export const TranslateSmallIcon = makeIcon({
  displayName: 'TranslateSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.2.75a.7.7 0 1 0-1.4 0v.85H.7A.7.7 0 1 0 .7 3h1.068l.013.096c.204 1.471.77 2.705 1.603 3.662a5.583 5.583 0 0 1-1.661.705.7.7 0 1 0 .34 1.358 6.901 6.901 0 0 0 2.383-1.093c.154.11.313.216.477.314l.419.25a.2.2 0 0 0 .28-.08l.447-.858a.2.2 0 0 0-.062-.256l-.366-.258a5.183 5.183 0 0 1-.132-.082c.829-.952 1.397-2.183 1.603-3.662A.707.707 0 0 0 7.118 3H8.3a.7.7 0 1 0 0-1.4H5.2V.75ZM5.71 3c-.177 1.16-.622 2.112-1.264 2.846C3.808 5.116 3.36 4.168 3.182 3H5.71Zm.013 8.892a.7.7 0 0 1-.366-.92l2.606-6.037a.699.699 0 0 1 .672-.499.698.698 0 0 1 .673.499l2.606 6.037a.7.7 0 1 1-1.286.554L9.97 10H7.301l-.658 1.526a.7.7 0 0 1-.92.366ZM9.365 8.6l-.73-1.691-.73 1.691h1.46Z"
      fill="currentColor"
    />
  ),
})

export const SpellcheckSmallIcon = makeIcon({
  displayName: 'SpellcheckSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.75.6a.75.75 0 0 0 0 1.5h10.453a.75.75 0 0 0 0-1.5H.75Zm0 3.5a.75.75 0 1 0 0 1.5H8a.75.75 0 0 0 0-1.5H.75Zm0 3.5a.75.75 0 1 0 0 1.5h2.5a.75.75 0 0 0 0-1.5H.75Zm11.053-.566a.75.75 0 0 0-1.224-.867L8.176 9.559 6.68 8.064a.75.75 0 0 0-1.06 1.06l1.956 1.957a.95.95 0 0 0 1.447-.123l2.78-3.924Z"
      fill="currentColor"
    />
  ),
})

export const MagicPenSmallIcon = makeIcon({
  displayName: 'MagicPenSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.08986 1.59981C8.94711 1.4563 8.71674 1.45431 8.57602 1.59536L7.83655 2.33653L9.64804 4.14802L10.3852 3.41083C10.5255 3.27059 10.524 3.0415 10.3819 2.89865L9.08986 1.59981ZM9.6628 6.2448L9.66768 6.24969L11.4459 4.47149C12.1616 3.75573 12.154 2.58651 11.4288 1.85745L10.1367 0.558609C9.40818 -0.17381 8.23239 -0.184 7.51417 0.535885L0.401217 7.6653C0.126227 7.94092 -0.0264756 8.31611 -0.0233917 8.70855L-0.00476676 11.0787C-0.000896662 11.5712 0.401504 11.9736 0.894 11.9775L3.26444 11.9961C3.65653 11.9992 4.03141 11.8467 4.30698 11.5722L4.93924 10.9423C5.22808 10.6545 5.22522 10.1833 4.93285 9.88992C4.64048 9.5965 4.16932 9.59192 3.88048 9.8797L3.25004 10.5078L1.4788 10.4939L1.46488 8.72295L6.77712 3.39842L9.64315 6.26445L9.6628 6.2448ZM7.33094 4.94872C7.29818 4.81113 7.10242 4.81113 7.06966 4.94872L6.79512 6.10182C6.54999 7.13141 5.72306 7.92105 4.68326 8.11843L3.89496 8.26808C3.7493 8.29573 3.7493 8.5043 3.89496 8.53195L4.68326 8.68159C5.72306 8.87898 6.54999 9.66862 6.79512 10.6982L7.06966 11.8513C7.10242 11.9889 7.29818 11.9889 7.33094 11.8513L7.60549 10.6981C7.85062 9.66858 8.6775 8.87896 9.71725 8.68154L10.5051 8.53195C10.6508 8.50429 10.6508 8.29574 10.5051 8.26808L9.71725 8.11849C8.6775 7.92107 7.85062 7.13145 7.60549 6.10189L7.33094 4.94872Z"
      fill="currentColor"
    />
  ),
})

export const ScissorsSmallIcon = makeIcon({
  displayName: 'ScissorsSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.88741 4.89345C3.51136 5.11981 3.07087 5.25 2.59998 5.25C1.21926 5.25 0.0999756 4.13071 0.0999756 2.75C0.0999756 1.36929 1.21926 0.25 2.59998 0.25C3.98069 0.25 5.09998 1.36929 5.09998 2.75C5.09998 3.11373 5.0223 3.45931 4.88263 3.77107L6.31803 5.01884L9.50435 2.24901L9.80915 1.98405C10.4344 1.44055 11.3818 1.50681 11.9253 2.13203L7.46122 6.0126L11.9253 9.89317C11.3818 10.5184 10.4344 10.5846 9.80915 10.0411L9.50435 9.77619L6.31803 7.00636L4.89069 8.24712C5.02529 8.55411 5.09998 8.89333 5.09998 9.25C5.09998 10.6307 3.98069 11.75 2.59998 11.75C1.21926 11.75 0.0999756 10.6307 0.0999756 9.25C0.0999756 7.86929 1.21926 6.75 2.59998 6.75C3.07801 6.75 3.52471 6.88417 3.90447 7.11691L5.17484 6.0126L3.88741 4.89345ZM2.59998 3.75C3.15226 3.75 3.59998 3.30228 3.59998 2.75C3.59998 2.19772 3.15226 1.75 2.59998 1.75C2.04769 1.75 1.59998 2.19772 1.59998 2.75C1.59998 3.30228 2.04769 3.75 2.59998 3.75ZM2.59998 10.25C3.15226 10.25 3.59998 9.80228 3.59998 9.25C3.59998 8.69772 3.15226 8.25 2.59998 8.25C2.04769 8.25 1.59998 8.69772 1.59998 9.25C1.59998 9.80228 2.04769 10.25 2.59998 10.25Z"
      fill="currentColor"
    />
  ),
})

export const EraserSmallIcon = makeIcon({
  displayName: 'EraserSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3283 4.22142L7.85341 1.74654C7.65815 1.55128 7.34156 1.55128 7.1463 1.74654L5.49624 3.39661L8.67822 6.57859L10.3283 4.92852C10.5235 4.73326 10.5235 4.41668 10.3283 4.22142ZM1.75668 7.13617L4.43558 4.45727L7.61756 7.63925L5.38158 9.87522C5.28804 9.96876 5.16126 10.0214 5.029 10.0217C5.02868 10.0217 5.02835 10.0217 5.02803 10.0217L4.30003 10.0217L4.14218 10.0217C4.00957 10.0217 3.88239 9.96899 3.78862 9.87522L1.75668 7.84328C1.56141 7.64801 1.56141 7.33143 1.75668 7.13617ZM4.30003 11.5217L4.14218 11.5217C3.61174 11.5217 3.10303 11.311 2.72796 10.9359L0.696017 8.90394C-0.085032 8.12289 -0.0850333 6.85656 0.696015 6.07551L6.08564 0.685885C6.86669 -0.0951638 8.13302 -0.0951651 8.91407 0.685883L11.3889 3.16076C12.17 3.94181 12.17 5.20814 11.3889 5.98918L7.35646 10.0217H11.2C11.6142 10.0217 11.95 10.3575 11.95 10.7717C11.95 11.1859 11.6142 11.5217 11.2 11.5217L5.02998 11.5217C5.02933 11.5217 5.02868 11.5217 5.02803 11.5217L4.30003 11.5217Z"
      fill="currentColor"
    />
  ),
})

export const PianoSmallIcon = makeIcon({
  displayName: 'PianoSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 1.5V10.5H3.50002V7.5H3.44995C3.17381 7.5 2.94995 7.27614 2.94995 7V1.5H1.5ZM5.44995 1.5V7C5.44995 7.27614 5.22609 7.5 4.94995 7.5H4.90002V10.5H7.00002V7.5H7C6.72386 7.5 6.5 7.27614 6.5 7V1.5H5.44995ZM8.40002 10.5V7.5H8.5C8.77614 7.5 9 7.27614 9 7V1.5H10.5V10.5H8.40002ZM1 0C0.447715 0 0 0.447715 0 1V11C0 11.5523 0.447715 12 1 12H11C11.5523 12 12 11.5523 12 11V1C12 0.447715 11.5523 0 11 0H1Z"
      fill="currentColor"
    />
  ),
})

export const HeaderOneSmallIcon = makeIcon({
  displayName: 'HeaderOneSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        d="M1.5 0.75C1.5 0.335786 1.16421 0 0.75 0C0.335786 0 0 0.335786 0 0.75V11.25C0 11.6642 0.335786 12 0.75 12C1.16421 12 1.5 11.6642 1.5 11.25V6.75H5.5V11.25C5.5 11.6642 5.83579 12 6.25 12C6.66421 12 7 11.6642 7 11.25V0.75C7 0.335786 6.66421 0 6.25 0C5.83579 0 5.5 0.335786 5.5 0.75V5.25H1.5V0.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4555 6.39305C11.2393 6.26882 10.9733 6.2691 10.7574 6.39357L9.25356 7.13438L9.25345 7.13415L9.24737 7.1377C8.91343 7.3325 8.80064 7.76112 8.99543 8.09506C9.18861 8.42622 9.61174 8.5399 9.94444 8.35179L10.4069 8.18658L10.4069 11.3C10.4069 11.6866 10.7203 12 11.1069 12C11.4935 12 11.8069 11.6866 11.8069 11.3L11.8069 7.00005C11.8069 6.7494 11.6729 6.51789 11.4555 6.39305Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const HeaderTwoSmallIcon = makeIcon({
  displayName: 'HeaderTwoSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        d="M1.5 0.75C1.5 0.335786 1.16421 0 0.75 0C0.335786 0 0 0.335786 0 0.75V11.25C0 11.6642 0.335786 12 0.75 12C1.16421 12 1.5 11.6642 1.5 11.25V6.75H5.5V11.25C5.5 11.6642 5.83579 12 6.25 12C6.66421 12 7 11.6642 7 11.25V0.75C7 0.335786 6.66421 0 6.25 0C5.83579 0 5.5 0.335786 5.5 0.75V5.25H1.5V0.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9917 7.03517C10.2145 6.41603 9.0919 6.55989 8.48943 7.34622C8.38773 7.47896 8.30694 7.62227 8.24695 7.77163C8.11316 8.10475 8.27475 8.48326 8.60788 8.61705C8.941 8.75084 9.3195 8.58924 9.45329 8.25612C9.46994 8.21468 9.49244 8.17461 9.52135 8.13687C9.6849 7.92342 9.97817 7.88985 10.1816 8.05195C10.3928 8.22014 10.4342 8.53971 10.2649 8.76067C10.095 8.98236 9.63547 9.49404 9.19306 9.97584C8.97716 10.211 8.77296 10.4308 8.62265 10.5919L8.37676 10.8545C8.19907 11.0434 8.15059 11.3197 8.25342 11.5578C8.35627 11.7958 8.59079 11.95 8.85012 11.95L11.2501 11.95C11.6091 11.95 11.9001 11.659 11.9001 11.3C11.9001 10.941 11.6091 10.65 11.2501 10.65L10.3383 10.65C10.7168 10.2351 11.1141 9.78975 11.2968 9.55133C11.8935 8.77249 11.7612 7.64823 10.9917 7.03517Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const HeaderThreeSmallIcon = makeIcon({
  displayName: 'HeaderThreeSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        d="M1.5 0.75C1.5 0.335786 1.16421 0 0.75 0C0.335786 0 0 0.335786 0 0.75V11.25C0 11.6642 0.335786 12 0.75 12C1.16421 12 1.5 11.6642 1.5 11.25V6.75H5.5V11.25C5.5 11.6642 5.83579 12 6.25 12C6.66421 12 7 11.6642 7 11.25V0.75C7 0.335786 6.66421 0 6.25 0C5.83579 0 5.5 0.335786 5.5 0.75V5.25H1.5V0.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1696 6.69995C9.74953 6.69995 9.36178 6.85222 9.06515 7.10627C8.85572 7.28564 8.69014 7.51708 8.59104 7.78314C8.46574 8.11955 8.63688 8.49384 8.97329 8.61913C9.3097 8.74443 9.68399 8.57329 9.80929 8.23688C9.82897 8.18405 9.86334 8.13428 9.9108 8.09363C9.97748 8.03652 10.067 7.99995 10.1696 7.99995C10.3977 7.99995 10.5502 8.17433 10.5502 8.34995C10.5502 8.52557 10.3977 8.69995 10.1696 8.69995C9.81065 8.69995 9.51963 8.99097 9.51963 9.34995C9.51963 9.70894 9.81065 9.99995 10.1696 9.99995C10.3977 9.99995 10.5502 10.1743 10.5502 10.35C10.5502 10.5256 10.3977 10.7 10.1696 10.7C10.067 10.7 9.97748 10.6634 9.9108 10.6063C9.86334 10.5656 9.82897 10.5159 9.80929 10.463C9.68399 10.1266 9.3097 9.95547 8.97329 10.0808C8.63688 10.2061 8.46574 10.5804 8.59104 10.9168C8.69014 11.1828 8.85572 11.4143 9.06515 11.5936C9.36178 11.8477 9.74953 12 10.1696 12C11.079 12 11.8502 11.2797 11.8502 10.35C11.8502 9.97033 11.7214 9.62519 11.507 9.34995C11.7214 9.07471 11.8502 8.72957 11.8502 8.34995C11.8502 7.42023 11.079 6.69995 10.1696 6.69995Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const HeaderFourSmallIcon = makeIcon({
  displayName: 'HeaderFourSmallIcon',
  viewBox: 12,
  content: (
    <g fill="currentColor">
      <path d="M1.5.75a.75.75 0 0 0-1.5 0v10.5a.75.75 0 0 0 1.5 0v-4.5h4v4.5a.75.75 0 0 0 1.5 0V.75a.75.75 0 0 0-1.5 0v4.5h-4V.75Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.371 6.65a.55.55 0 0 0-.452.237l-1.821 2.63A.55.55 0 0 0 8 9.832v.202c0 .304.246.55.55.55h1.474v.867a.55.55 0 0 0 1.1 0v-.867h.26a.55.55 0 0 0 0-1.1h-.26V7.2a.55.55 0 0 0-.55-.55h-.203Zm-.347 2.018v.815H9.46V9.4l.49-.732h.074Z"
      />
    </g>
  ),
})

export const AttachmentSmallIcon = makeIcon({
  displayName: 'AttachmentSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8454 1.15456C9.77261 0.0817808 8.03329 0.0817807 6.96051 1.15456L1.15456 6.96051C0.0817809 8.03329 0.0817806 9.77261 1.15456 10.8454C2.22734 11.9182 3.96666 11.9182 5.03944 10.8454L8.30529 7.57954C8.97725 6.90758 8.97725 5.81811 8.30529 5.14615C7.63333 4.47419 6.54386 4.47419 5.8719 5.14615L3.39391 7.62414C3.12277 7.89529 3.12277 8.3349 3.39391 8.60604C3.66505 8.87718 4.10467 8.87719 4.37581 8.60604L6.8538 6.12805C6.98347 5.99838 7.19371 5.99838 7.32339 6.12805C7.45306 6.25772 7.45306 6.46797 7.32339 6.59764L4.05754 9.86349C3.52705 10.394 2.66695 10.394 2.13646 9.86349C1.60597 9.333 1.60597 8.47291 2.13646 7.94241L7.94241 2.13646C8.47291 1.60597 9.333 1.60597 9.86349 2.13646C10.394 2.66695 10.394 3.52705 9.86349 4.05754L9.50062 4.42041C9.22947 4.69155 9.22947 5.13117 9.50062 5.40231C9.77176 5.67345 10.2114 5.67345 10.4825 5.40231L10.8454 5.03944C11.9182 3.96666 11.9182 2.22734 10.8454 1.15456Z"
        fill="currentColor"
      />
    </g>
  ),
})
export const BoldSmallIcon = makeIcon({
  displayName: 'BoldSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        d="M1.75 0.716418C1.75 0.320751 1.69575 0 2.09142 0H3.88246V6.375V12H2.09142C1.69575 12 1.75 11.6792 1.75 11.2836V0.716418Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99869 0H2.44963V6H7.37369C9.02042 6 9.99374 4.7803 10.0422 3.13429C10.0926 1.41838 8.71534 0 6.99869 0ZM5.43335 1.125H3.88246V5.25H5.43335C6.62496 5.25 7.77801 4.6875 7.77801 3.26765C7.77801 1.8478 6.81246 1.09142 5.43335 1.125Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.91232 5.37313H2.44963V12H7.53732C9.36728 12 10.8508 10.5165 10.8508 8.68657C10.8508 6.85661 9.74228 5.37313 7.91232 5.37313ZM6.05011 6.375H3.88246V10.875H6.0501C7.26564 10.875 8.28827 10.3125 8.28827 8.56118C8.28827 6.9375 7.3076 6.375 6.05011 6.375Z"
        fill="currentColor"
      />
      <path
        d="M1 0.5625C1 0.25184 1.25184 0 1.5625 0H2.3125C2.62316 0 2.875 0.25184 2.875 0.5625C2.875 0.87316 2.62316 1.125 2.3125 1.125H1.5625C1.25184 1.125 1 0.87316 1 0.5625Z"
        fill="currentColor"
      />
      <path
        d="M1 11.4375C1 11.1268 1.25184 10.875 1.5625 10.875H2.3125C2.62316 10.875 2.875 11.1268 2.875 11.4375C2.875 11.7482 2.62316 12 2.3125 12H1.5625C1.25184 12 1 11.7482 1 11.4375Z"
        fill="currentColor"
      />
    </g>
  ),
})
export const BulletListSmallIcon = makeIcon({
  displayName: 'BulletListSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 2.25C4.25 1.83579 4.58579 1.5 5 1.5H11.25C11.6642 1.5 12 1.83579 12 2.25C12 2.66421 11.6642 3 11.25 3H5C4.58579 3 4.25 2.66421 4.25 2.25ZM4.25 6C4.25 5.58579 4.58579 5.25 5 5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H5C4.58579 6.75 4.25 6.41421 4.25 6ZM4.25 9.75C4.25 9.33579 4.58579 9 5 9H11.25C11.6642 9 12 9.33579 12 9.75C12 10.1642 11.6642 10.5 11.25 10.5H5C4.58579 10.5 4.25 10.1642 4.25 9.75Z"
        fill="currentColor"
      />
      <circle cx="1.125" cy="9.72498" r="1.125" fill="currentColor" />
      <circle cx="1.125" cy="6.02502" r="1.125" fill="currentColor" />
      <circle cx="1.125" cy="2.22498" r="1.125" fill="currentColor" />
    </g>
  ),
})
export const BlockCodeSmallIcon = makeIcon({
  displayName: 'BlockCodeSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        d="M1.59791 5.21197C1.70241 5.09006 1.84032 4.75726 1.66092 3.86023C1.33968 2.25406 1.46361 1.4176 2.13075 0.797726C2.45659 0.494977 2.8525 0.363867 3.21688 0.302838C3.57317 0.243162 3.95082 0.243165 4.26898 0.243167H4.27499C4.58565 0.243166 4.83749 0.495007 4.83749 0.805667C4.83749 1.11633 4.58565 1.36817 4.27499 1.36817C3.93815 1.36817 3.65308 1.37045 3.40272 1.41238C3.15819 1.45334 3.00155 1.5243 2.89651 1.62189C2.70192 1.80269 2.45085 2.07348 2.76407 3.6396C2.95966 4.61757 2.91008 5.40977 2.45208 5.94411C2.43564 5.96328 2.41888 5.98188 2.40182 5.99991C2.41888 6.01795 2.43564 6.03654 2.45208 6.05572C2.91008 6.59006 2.95966 7.38226 2.76407 8.36023C2.45085 9.92635 2.70192 10.2096 2.89651 10.3904C3.00155 10.488 3.15819 10.559 3.40272 10.5999C3.65308 10.6418 3.93815 10.6441 4.27499 10.6441C4.58565 10.6441 4.83749 10.896 4.83749 11.2066C4.83749 11.5173 4.58565 11.7691 4.27499 11.7691H4.26898C3.95082 11.7691 3.57317 11.7691 3.21688 11.7095C2.8525 11.6484 2.45659 11.5173 2.13075 11.2146C1.46361 10.5947 1.33968 9.74577 1.66092 8.1396C1.84032 7.24257 1.70241 6.90977 1.59791 6.78786C1.49045 6.66249 1.25356 6.56241 0.712494 6.56241C0.401834 6.56241 0.149994 6.31057 0.149994 5.99991C0.149994 5.68925 0.401834 5.43741 0.712494 5.43741C1.25356 5.43741 1.49045 5.33734 1.59791 5.21197Z"
        fill="currentColor"
      />
      <path
        d="M10.3337 3.86023C10.1543 4.75726 10.2922 5.09006 10.3967 5.21197C10.5042 5.33734 10.7411 5.43741 11.2821 5.43741C11.5928 5.43741 11.8446 5.68925 11.8446 5.99991C11.8446 6.31057 11.5928 6.56241 11.2821 6.56241C10.7411 6.56241 10.5042 6.66249 10.3967 6.78786C10.2922 6.90977 10.1543 7.24257 10.3337 8.1396C10.6549 9.74577 10.531 10.5947 9.86386 11.2146C9.53802 11.5173 9.14211 11.6484 8.77773 11.7095C8.42144 11.7691 8.04379 11.7691 7.72564 11.7691H7.71962C7.40896 11.7691 7.15712 11.5173 7.15712 11.2066C7.15712 10.896 7.40896 10.6441 7.71962 10.6441C8.05646 10.6441 8.34154 10.6418 8.5919 10.5999C8.83642 10.559 8.99307 10.488 9.0981 10.3904C9.29269 10.2096 9.54377 9.92635 9.23054 8.36023C9.03495 7.38226 9.08453 6.59006 9.54254 6.05572C9.55897 6.03654 9.57573 6.01795 9.59279 5.99991C9.57573 5.98188 9.55897 5.96328 9.54254 5.94411C9.08453 5.40977 9.03495 4.61757 9.23054 3.6396C9.54377 2.07348 9.29269 1.80269 9.0981 1.62189C8.99307 1.5243 8.83642 1.45334 8.5919 1.41238C8.34154 1.37045 8.05646 1.36817 7.71962 1.36817C7.40896 1.36817 7.15712 1.11633 7.15712 0.805667C7.15712 0.495007 7.40896 0.243166 7.71962 0.243167H7.72564C8.04379 0.243165 8.42144 0.243162 8.77773 0.302838C9.14211 0.363867 9.53802 0.494977 9.86386 0.797726C10.531 1.4176 10.6549 2.25406 10.3337 3.86023Z"
        fill="currentColor"
      />
      <path
        d="M1.59791 5.21197C1.70241 5.09006 1.84032 4.75726 1.66092 3.86023C1.33968 2.25406 1.46361 1.4176 2.13075 0.797726C2.45659 0.494977 2.8525 0.363867 3.21688 0.302838C3.57317 0.243162 3.95082 0.243165 4.26898 0.243167H4.27499C4.58565 0.243166 4.83749 0.495007 4.83749 0.805667C4.83749 1.11633 4.58565 1.36817 4.27499 1.36817C3.93815 1.36817 3.65308 1.37045 3.40272 1.41238C3.15819 1.45334 3.00155 1.5243 2.89651 1.62189C2.70192 1.80269 2.45085 2.07348 2.76407 3.6396C2.95966 4.61757 2.91008 5.40977 2.45208 5.94411C2.43564 5.96328 2.41888 5.98188 2.40182 5.99991C2.41888 6.01795 2.43564 6.03654 2.45208 6.05572C2.91008 6.59006 2.95966 7.38226 2.76407 8.36023C2.45085 9.92635 2.70192 10.2096 2.89651 10.3904C3.00155 10.488 3.15819 10.559 3.40272 10.5999C3.65308 10.6418 3.93815 10.6441 4.27499 10.6441C4.58565 10.6441 4.83749 10.896 4.83749 11.2066C4.83749 11.5173 4.58565 11.7691 4.27499 11.7691H4.26898C3.95082 11.7691 3.57317 11.7691 3.21688 11.7095C2.8525 11.6484 2.45659 11.5173 2.13075 11.2146C1.46361 10.5947 1.33968 9.74577 1.66092 8.1396C1.84032 7.24257 1.70241 6.90977 1.59791 6.78786C1.49045 6.66249 1.25356 6.56241 0.712494 6.56241C0.401834 6.56241 0.149994 6.31057 0.149994 5.99991C0.149994 5.68925 0.401834 5.43741 0.712494 5.43741C1.25356 5.43741 1.49045 5.33734 1.59791 5.21197Z"
        stroke="currentColor"
        strokeWidth="0.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.3337 3.86023C10.1543 4.75726 10.2922 5.09006 10.3967 5.21197C10.5042 5.33734 10.7411 5.43741 11.2821 5.43741C11.5928 5.43741 11.8446 5.68925 11.8446 5.99991C11.8446 6.31057 11.5928 6.56241 11.2821 6.56241C10.7411 6.56241 10.5042 6.66249 10.3967 6.78786C10.2922 6.90977 10.1543 7.24257 10.3337 8.1396C10.6549 9.74577 10.531 10.5947 9.86386 11.2146C9.53802 11.5173 9.14211 11.6484 8.77773 11.7095C8.42144 11.7691 8.04379 11.7691 7.72564 11.7691H7.71962C7.40896 11.7691 7.15712 11.5173 7.15712 11.2066C7.15712 10.896 7.40896 10.6441 7.71962 10.6441C8.05646 10.6441 8.34154 10.6418 8.5919 10.5999C8.83642 10.559 8.99307 10.488 9.0981 10.3904C9.29269 10.2096 9.54377 9.92635 9.23054 8.36023C9.03495 7.38226 9.08453 6.59006 9.54254 6.05572C9.55897 6.03654 9.57573 6.01795 9.59279 5.99991C9.57573 5.98188 9.55897 5.96328 9.54254 5.94411C9.08453 5.40977 9.03495 4.61757 9.23054 3.6396C9.54377 2.07348 9.29269 1.80269 9.0981 1.62189C8.99307 1.5243 8.83642 1.45334 8.5919 1.41238C8.34154 1.37045 8.05646 1.36817 7.71962 1.36817C7.40896 1.36817 7.15712 1.11633 7.15712 0.805667C7.15712 0.495007 7.40896 0.243166 7.71962 0.243167H7.72564C8.04379 0.243165 8.42144 0.243162 8.77773 0.302838C9.14211 0.363867 9.53802 0.494977 9.86386 0.797726C10.531 1.4176 10.6549 2.25406 10.3337 3.86023Z"
        stroke="currentColor"
        strokeWidth="0.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  ),
})
export const CommentsEmptySmallIcon = makeIcon({
  displayName: 'CommentsEmptySmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 5.75C0.25 2.85051 2.60051 0.5 5.5 0.5H6.96263C9.60662 0.5 11.75 2.64338 11.75 5.28737C11.75 7.93136 9.60662 10.0747 6.96263 10.0747H4.42406C4.3542 10.0747 4.28574 10.0943 4.22637 10.1311L1.96806 11.5321C1.21863 11.997 0.25 11.458 0.25 10.5761V5.75ZM5.5 2C3.42893 2 1.75 3.67893 1.75 5.75V9.90213L3.43563 8.85643C3.73244 8.6723 4.07478 8.57474 4.42406 8.57474H6.96263C8.77819 8.57474 10.25 7.10294 10.25 5.28737C10.25 3.47181 8.77819 2 6.96263 2H5.5Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const CommentsFullSmallIcon = makeIcon({
  displayName: 'CommentsFullSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.25 5.75C0.25 2.85051 2.60051 0.5 5.5 0.5H6.96263C9.60662 0.5 11.75 2.64338 11.75 5.28737C11.75 7.93136 9.60662 10.0747 6.96263 10.0747H4.42406C4.3542 10.0747 4.28574 10.0943 4.22637 10.1311L1.96806 11.5321C1.21863 11.997 0.25 11.458 0.25 10.5761V5.75Z"
      fill="currentColor"
    />
  ),
})

export const CreateNoteSmallIcon = makeIcon({
  displayName: 'CreateNoteSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path d="M0.5 9.75C0.5 10.9926 1.50736 12 2.75 12H9.25C10.4926 12 11.5 10.9926 11.5 9.75V8C11.5 7.58579 11.1642 7.25 10.75 7.25C10.3358 7.25 10 7.58579 10 8V9.75C10 10.1642 9.66421 10.5 9.25 10.5H2.75C2.33579 10.5 2 10.1642 2 9.75V2.25C2 1.83579 2.33579 1.5 2.75 1.5H4.5C4.91421 1.5 5.25 1.16421 5.25 0.75C5.25 0.335787 4.91421 0 4.5 0H2.75C1.50736 0 0.5 1.00736 0.5 2.25V9.75Z" />
      <path d="M6.5 2.75C6.5 2.33579 6.83579 2 7.25 2L8.5 2V0.75C8.5 0.335786 8.83579 0 9.25 0C9.66421 0 10 0.335786 10 0.75V2L11.25 2C11.6642 2 12 2.33579 12 2.75C12 3.16421 11.6642 3.5 11.25 3.5L10 3.5V4.75C10 5.16421 9.66421 5.5 9.25 5.5C8.83579 5.5 8.5 5.16421 8.5 4.75V3.5L7.25 3.5C6.83579 3.5 6.5 3.16421 6.5 2.75Z" />
    </g>
  ),
})

export const CommentsAddSmallIcon = makeIcon({
  displayName: 'CommentsAddSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path d="M8.75 0C9.16421 0 9.5 0.335786 9.5 0.75V2H10.75C11.1642 2 11.5 2.33579 11.5 2.75C11.5 3.16421 11.1642 3.5 10.75 3.5H9.5V4.75C9.5 5.16421 9.16421 5.5 8.75 5.5C8.33579 5.5 8 5.16421 8 4.75V3.5H6.75C6.33579 3.5 6 3.16421 6 2.75C6 2.33579 6.33579 2 6.75 2H8V0.75C8 0.335786 8.33579 0 8.75 0Z" />
      <path d="M4.5 2.25C2.98122 2.25 1.75 3.48122 1.75 5V10.1521L3.43563 9.10643C3.73244 8.9223 4.07478 8.82474 4.42406 8.82474H7.67526C9.09725 8.82474 10.25 7.67199 10.25 6.25V6C10.25 5.58579 10.5858 5.25 11 5.25C11.4142 5.25 11.75 5.58579 11.75 6V6.25C11.75 8.50042 9.92568 10.3247 7.67526 10.3247H4.42406C4.3542 10.3247 4.28574 10.3443 4.22637 10.3811L1.96806 11.7821C1.21863 12.247 0.25 11.708 0.25 10.8261V5C0.25 2.65279 2.15279 0.75 4.5 0.75C4.91421 0.75 5.25 1.08579 5.25 1.5C5.25 1.91421 4.91421 2.25 4.5 2.25Z" />
    </g>
  ),
})
export const CommentsSmallIcon = makeIcon({
  displayName: 'CommentsSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 5.75C0.25 2.85051 2.60051 0.5 5.5 0.5H6.96263C9.60662 0.5 11.75 2.64338 11.75 5.28737C11.75 7.93136 9.60662 10.0747 6.96263 10.0747H4.42406C4.3542 10.0747 4.28574 10.0943 4.22637 10.1311L1.96806 11.5321C1.21863 11.997 0.25 11.458 0.25 10.5761V5.75ZM5.5 2C3.42893 2 1.75 3.67893 1.75 5.75V9.90213L3.43563 8.85643C3.73244 8.6723 4.07478 8.57474 4.42406 8.57474H6.96263C8.77819 8.57474 10.25 7.10294 10.25 5.28737C10.25 3.47181 8.77819 2 6.96263 2H5.5Z"
        fill="currentColor"
      />
    </g>
  ),
})
export const DeleteSmallIcon = makeIcon({
  displayName: 'DeleteSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3C0.585786 3 0.25 3.33579 0.25 3.75C0.25 4.16421 0.585786 4.5 1 4.5H1.83141L2.97379 10.5292C3.10796 11.2374 3.72682 11.75 4.44757 11.75H7.61968C8.34618 11.75 8.96825 11.2293 9.09622 10.5142L10.1724 4.5H11C11.4142 4.5 11.75 4.16421 11.75 3.75C11.75 3.33579 11.4142 3 11 3H1ZM8.64862 4.5H3.3581L4.44757 10.25H7.61968L8.64862 4.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 1C2.75 0.585787 3.08579 0.25 3.5 0.25L8.5 0.25C8.91421 0.25 9.25 0.585786 9.25 1C9.25 1.41421 8.91421 1.75 8.5 1.75L3.5 1.75C3.08579 1.75 2.75 1.41421 2.75 1Z"
      />
    </g>
  ),
})
export const DiagramSmallIcon = makeIcon({
  displayName: 'DiagramSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 1.5V3.5H7.5V1.5H4.5ZM4 0C3.44772 0 3 0.447715 3 1V4C3 4.55228 3.4477 4.99999 3.99998 5L1.99999 6.99997L2.00002 7H1C0.447715 7 0 7.44772 0 8V10.5C0 11.0523 0.447715 11.5 1 11.5H4.5C5.05228 11.5 5.5 11.0523 5.5 10.5V8C5.5 7.44772 5.05228 7 4.5 7H4.11836L5.99999 5.11839L7.88161 7H7.5C6.94772 7 6.5 7.44772 6.5 8V10.5C6.5 11.0523 6.94772 11.5 7.5 11.5H11C11.5523 11.5 12 11.0523 12 10.5V8C12 7.44772 11.5523 7 11 7H10L8 5C8.55228 5 9 4.55228 9 4V1C9 0.447715 8.55228 0 8 0H4ZM1.5 8.5V10H4V8.5H1.5ZM8 10V8.5H10.5V10H8Z"
      fill="currentColor"
    />
  ),
})
export const DirectorySmallIcon = makeIcon({
  displayName: 'DirectorySmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.18373 1.58755C6.09084 1.53332 5.97603 1.53297 5.88282 1.58663L1.69474 3.99747C1.49399 4.11303 1.49437 4.40284 1.69543 4.51787L5.88351 6.91403C5.97637 6.96716 6.09051 6.96681 6.18305 6.91312L10.3127 4.51696C10.5116 4.40152 10.512 4.11436 10.3133 3.99839L6.18373 1.58755ZM11.0696 2.70299L6.93998 0.292142C6.38265 -0.0332241 5.69379 -0.0353268 5.13448 0.286635L0.946404 2.69748C-0.258084 3.39083 -0.2558 5.12965 0.950521 5.81983L5.1386 8.21599C5.6958 8.53479 6.38061 8.53271 6.93586 8.21053L11.0655 5.81437C12.2591 5.12176 12.2614 3.39877 11.0696 2.70299ZM11.6366 8.89556C11.9973 8.6918 12.1244 8.23427 11.9207 7.87364C11.7169 7.51301 11.2594 7.38584 10.8988 7.5896L6.0341 10.3381L1.18564 7.59008C0.825289 7.38583 0.367589 7.51238 0.163342 7.87274C-0.0409053 8.2331 0.0856458 8.6908 0.446001 8.89504L5.516 11.7687C5.83672 11.9505 6.22929 11.9507 6.55025 11.7694L6.18132 11.1164L6.55026 11.7694L11.6366 8.89556Z"
      fill="currentColor"
    />
  ),
})
export const AIGeneratedDirectorySmallIcon = makeIcon({
  displayName: 'AIGeneratedDirectorySmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path d="M11.0377 5.54132C12.1326 4.79737 12.037 3.15413 10.8633 2.54213L6.73284 0.388461C6.13327 0.0758342 5.41181 0.110254 4.84472 0.478541L1.02846 2.95695C-0.095206 3.6867 -0.0155286 5.35688 1.17251 5.97634L4.99087 7.96729C5.35815 8.1588 5.81114 8.0163 6.00265 7.64902C6.19416 7.28173 6.05166 6.82874 5.68438 6.63724L1.86602 4.64629C1.6963 4.55779 1.68492 4.3192 1.84544 4.21494L5.66171 1.73653C5.77512 1.66287 5.91941 1.65599 6.03933 1.71851L10.1697 3.87218C10.3374 3.95961 10.3511 4.19436 10.1947 4.30064L10.0785 4.37957C9.73589 4.61237 9.64687 5.07883 9.87967 5.42143C10.1125 5.76404 10.5789 5.85305 10.9215 5.62026L11.0377 5.54132Z" />
      <path d="M9.14652 5.9885C9.11837 5.87027 8.95014 5.87027 8.92199 5.9885L8.68607 6.9794C8.47542 7.86416 7.76481 8.54272 6.87128 8.71234L6.19387 8.84094C6.0687 8.8647 6.0687 9.04393 6.19387 9.06769L6.87128 9.19629C7.76481 9.36591 8.47542 10.0445 8.68607 10.9292L8.92199 11.9201C8.95014 12.0384 9.11837 12.0384 9.14652 11.9201L9.38245 10.9292C9.5931 10.0444 10.3037 9.36589 11.1972 9.19624L11.8742 9.06769C11.9994 9.04392 11.9994 8.86471 11.8742 8.84094L11.1972 8.71239C10.3037 8.54274 9.5931 7.86419 9.38245 6.97946L9.14652 5.9885Z" />
      <path d="M6.53742 10.5953C6.89903 10.7973 7.02841 11.2542 6.82639 11.6158C6.62437 11.9774 6.16746 12.1068 5.80585 11.9048L0.384228 8.87595C0.0226184 8.67393 -0.106757 8.21702 0.0952598 7.85541C0.297277 7.4938 0.754187 7.36442 1.1158 7.56644L6.53742 10.5953Z" />
    </g>
  ),
})

export const DocCardSmallIcon = makeIcon({
  displayName: 'DocCardSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 1C1.00736 1 0 2.00736 0 3.25V8.75C0 9.99264 1.00736 11 2.25 11H9.75C10.9926 11 12 9.99264 12 8.75V3.25C12 2.00736 10.9926 1 9.75 1H2.25ZM1.5 3.25C1.5 2.83579 1.83579 2.5 2.25 2.5H9.75C10.1642 2.5 10.5 2.83579 10.5 3.25V8.75C10.5 9.16421 10.1642 9.5 9.75 9.5H2.25C1.83579 9.5 1.5 9.16421 1.5 8.75V3.25ZM3.69231 6.5C3.30996 6.5 3 6.83579 3 7.25C3 7.66421 3.30996 8 3.69231 8H8.30769C8.69004 8 9 7.66421 9 7.25C9 6.83579 8.69004 6.5 8.30769 6.5H3.69231Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5C3 4.58579 3.30996 4.25 3.69231 4.25H5.80769C6.19004 4.25 6.5 4.58579 6.5 5C6.5 5.41421 6.19004 5.75 5.80769 5.75H3.69231C3.30996 5.75 3 5.41421 3 5Z"
        fill="currentColor"
      />
    </g>
  ),
})
export const EmbedSmallIcon = makeIcon({
  displayName: 'EmbedSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 0C1.23122 0 0 1.23122 0 2.75V9.25C0 10.7688 1.23122 12 2.75 12H9.25C10.7688 12 12 10.7688 12 9.25V2.75C12 1.23122 10.7688 0 9.25 0H2.75ZM1.5 2.75C1.5 2.05964 2.05964 1.5 2.75 1.5H9.25C9.94036 1.5 10.5 2.05964 10.5 2.75V9.25C10.5 9.94036 9.94036 10.5 9.25 10.5H2.75C2.05964 10.5 1.5 9.94036 1.5 9.25V2.75ZM8 6.43302C8.33333 6.24057 8.33333 5.75945 8 5.567L5 3.83494C4.66667 3.64249 4.25 3.88306 4.25 4.26796V7.73206C4.25 8.11696 4.66667 8.35752 5 8.16507L8 6.43302Z"
        fill="currentColor"
      />
    </g>
  ),
})
export const ExpandSmallIcon = makeIcon({
  displayName: 'ExpandSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 -3.84376e-06C7.08579 -3.82565e-06 6.75 0.335783 6.75 0.749996C6.75 1.16421 7.08579 1.5 7.5 1.5L9.43946 1.5L6.96979 3.96967C6.67689 4.26256 6.67689 4.73744 6.96979 5.03033C7.26268 5.32322 7.73756 5.32322 8.03045 5.03033L10.5 2.56077V4.5C10.5 4.91421 10.8358 5.25 11.25 5.25C11.6642 5.25 12 4.91421 12 4.5V0.749996C12 0.335782 11.6642 -4.02578e-06 11.25 -4.00767e-06L7.5 -3.84376e-06ZM0.749996 5.25C0.335783 5.25 -3.81097e-06 4.91421 -3.81097e-06 4.5V0.75C-3.81097e-06 0.335786 0.335783 0 0.749996 0H4.5C4.91421 0 5.25 0.335786 5.25 0.75C5.25 1.16421 4.91421 1.5 4.5 1.5H2.56077L5.03033 3.96955C5.32322 4.26244 5.32322 4.73732 5.03033 5.03021C4.73744 5.32311 4.26256 5.32311 3.96967 5.03021L1.5 2.56054V4.5C1.5 4.91421 1.16421 5.25 0.749996 5.25ZM11.25 6.74988C11.6642 6.74988 12 7.08566 12 7.49988V11.2499C12 11.6641 11.6642 11.9999 11.25 11.9999H7.5C7.08579 11.9999 6.75 11.6641 6.75 11.2499C6.75 10.8357 7.08579 10.4999 7.5 10.4999H9.43923L6.96967 8.03033C6.67678 7.73743 6.67678 7.26256 6.96967 6.96967C7.26256 6.67677 7.73744 6.67677 8.03033 6.96966L10.5 9.43933V7.49988C10.5 7.08566 10.8358 6.74988 11.25 6.74988ZM5.25 11.25C5.25 11.6642 4.91421 12 4.5 12H0.75C0.335787 12 0 11.6642 0 11.25V7.5C0 7.08579 0.335786 6.75 0.75 6.75C1.16421 6.75 1.5 7.08579 1.5 7.5L1.5 9.43923L3.96955 6.96967C4.26244 6.67678 4.73732 6.67678 5.03021 6.96967C5.32311 7.26256 5.32311 7.73744 5.03021 8.03033L2.56054 10.5H4.5C4.91421 10.5 5.25 10.8358 5.25 11.25Z"
      fill="currentColor"
    />
  ),
})
export const HighlightSmallIcon = makeIcon({
  displayName: 'HighlightSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.09087 4.70643L5.20163 0.499999C5.34232 0.223021 5.6809 0.112536 5.95788 0.253223C6.13424 0.342804 6.2431 0.512617 6.2626 0.695672C6.2431 0.512626 6.13424 0.342823 5.95788 0.253246C5.68091 0.112559 5.34232 0.223044 5.20163 0.500021L3.09087 4.70645L3.09087 4.70643ZM4.2051 8.54515L3.20259 10.695H0.754209C0.443549 10.695 0.191709 10.9469 0.191709 11.2575C0.191709 11.2576 0.191711 11.2576 0.191711 11.2576C0.191711 10.9469 0.443551 10.6951 0.754211 10.6951H3.20259L4.2051 8.54518L4.2051 8.54515ZM11.749 5.57207C11.7088 5.43382 11.616 5.31088 11.4799 5.23602C11.2077 5.0863 10.8656 5.18559 10.7159 5.4578L9.82072 7.08531L4.458 4.4991L4.45799 4.49912L9.82072 7.08533L10.7159 5.45782C10.8656 5.18562 11.2077 5.08633 11.4799 5.23604C11.616 5.3109 11.7088 5.43383 11.749 5.57207ZM6.04393 0.0838236C6.41429 0.271944 6.56213 0.724559 6.37432 1.095L4.71419 4.41172L9.74103 6.83594L10.5494 5.36623C10.7497 5.00208 11.2073 4.86925 11.5714 5.06954C11.9356 5.26983 12.0684 5.7274 11.8681 6.09155L10.6005 8.39613L7.4094 10.109L6.733 11.5596C6.63642 11.7667 6.45758 11.9092 6.25352 11.9663C6.17433 11.9946 6.08899 12.01 6.00006 12.01H0.754209C0.338615 12.01 0.00170898 11.6731 0.00170898 11.2575C0.00170898 10.842 0.338615 10.505 0.754209 10.505H3.08154L4.00273 8.52956L2.88763 4.68782L5.03223 0.413953C5.22044 0.0434192 5.67339 -0.104385 6.04393 0.0838236ZM4.4439 10.695H5.68519L6.09588 9.81431L6.09589 9.81432L5.68519 10.6951H4.44389L4.4439 10.695ZM4.74213 10.505L5.1682 9.59134L5.84339 9.90619L5.56414 10.505H4.74213ZM5.43171 8.05364L6.8381 8.70945L8.30226 7.82165L4.88063 6.15508L5.43171 8.05364ZM8.69874 7.80344L6.8498 8.92455L5.27327 8.1894L5.27327 8.18943L6.84981 8.92457L8.69876 7.80345L8.69874 7.80344Z"
      fill="currentColor"
    />
  ),
})
export const ImageSmallIcon = makeIcon({
  displayName: 'ImageSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2.75C0 1.23122 1.23122 0 2.75 0H9.25C10.7688 0 12 1.23122 12 2.75V9.25C12 10.7688 10.7688 12 9.25 12H2.75C1.23122 12 0 10.7688 0 9.25V2.75ZM2.75 1.5C2.05964 1.5 1.5 2.05964 1.5 2.75V5.96371C2.76327 5.53489 4.60742 5.41694 6.44831 6.78945C7.3118 7.43324 8.24462 7.67593 9.01442 7.6785C9.40035 7.67979 9.73187 7.62065 9.98367 7.53224C10.2462 7.44006 10.3721 7.33457 10.4133 7.28275C10.4401 7.24918 10.4691 7.21852 10.5 7.19081V2.75C10.5 2.05964 9.94036 1.5 9.25 1.5H2.75ZM10.5 8.94065C10.4936 8.94296 10.4871 8.94525 10.4806 8.94751C10.0479 9.09947 9.54412 9.18028 9.00941 9.17849C7.93794 9.17491 6.68823 8.83935 5.55172 7.992C3.94568 6.79459 2.375 7.14499 1.5 7.58385V9.25C1.5 9.94036 2.05964 10.5 2.75 10.5H9.25C9.94036 10.5 10.5 9.94036 10.5 9.25V8.94065ZM9.5 4C9.5 4.82843 8.82843 5.5 8 5.5C7.17157 5.5 6.5 4.82843 6.5 4C6.5 3.17157 7.17157 2.5 8 2.5C8.82843 2.5 9.5 3.17157 9.5 4Z"
      fill="currentColor"
    />
  ),
})
export const InfoSmallIcon = makeIcon({
  displayName: 'InfoSmallIcon',
  viewBox: 12,
  content: (
    <g clipPath="url(#clip0_3218_999)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 1.5C8.48528 1.5 10.5 3.51472 10.5 6C10.5 8.48528 8.48528 10.5 6 10.5C3.51472 10.5 1.5 8.48528 1.5 6C1.5 3.51472 3.51472 1.5 6 1.5ZM6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 9C6.41421 9 6.75 8.70372 6.75 8.33824V5.91176C6.75 5.54628 6.41421 5.25 6 5.25C5.58579 5.25 5.25 5.54628 5.25 5.91176V8.33824C5.25 8.70372 5.58579 9 6 9Z"
        fill="currentColor"
      />
      <path
        d="M6.75 3.75C6.75 3.33579 6.41421 3 6 3C5.58579 3 5.25 3.33579 5.25 3.75C5.25 4.16421 5.58579 4.5 6 4.5C6.41421 4.5 6.75 4.16421 6.75 3.75Z"
        fill="currentColor"
      />
    </g>
  ),
})
export const ItalicSmallIcon = makeIcon({
  displayName: 'ItalicSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.30196 0.75C4.30196 0.335786 4.63774 0 5.05196 0H10.75C11.1642 0 11.5 0.335786 11.5 0.75C11.5 1.16421 11.1642 1.5 10.75 1.5H8.53472L5.05196 10.5H6.94804C7.36225 10.5 7.69804 10.8358 7.69804 11.25C7.69804 11.6642 7.36225 12 6.94804 12H1.25C0.835786 12 0.5 11.6642 0.5 11.25C0.5 10.8358 0.835786 10.5 1.25 10.5H3.46528L6.94804 1.5H5.05196C4.63774 1.5 4.30196 1.16421 4.30196 0.75Z"
      fill="currentColor"
    />
  ),
})
export const MathSmallIcon = makeIcon({
  displayName: 'MathSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        d="M5.625 1.365C5.10723 1.365 4.6875 1.78473 4.6875 2.3025L4.6875 4.49992H5.8125C6.12316 4.49992 6.375 4.75176 6.375 5.06242C6.375 5.37308 6.12316 5.62492 5.8125 5.62492H4.6875L4.6875 9.6313C4.6875 10.7704 3.76409 11.6938 2.625 11.6938C1.48591 11.6938 0.5625 10.7704 0.5625 9.6313C0.5625 9.32064 0.81434 9.0688 1.125 9.0688C1.43566 9.0688 1.6875 9.32064 1.6875 9.6313C1.6875 10.1491 2.10723 10.5688 2.625 10.5688C3.14277 10.5688 3.5625 10.1491 3.5625 9.6313L3.5625 5.62492H2.4375C2.12684 5.62492 1.875 5.37308 1.875 5.06242C1.875 4.75176 2.12684 4.49992 2.4375 4.49992H3.5625L3.5625 2.3025C3.5625 1.16341 4.48591 0.239999 5.625 0.239999C6.76409 0.239999 7.6875 1.16341 7.6875 2.3025C7.6875 2.61316 7.43566 2.865 7.125 2.865C6.81434 2.865 6.5625 2.61316 6.5625 2.3025C6.5625 1.78473 6.14277 1.365 5.625 1.365Z"
        fill="currentColor"
      />
      <path
        d="M9.15925 9.6313L10.3525 8.43805C10.5722 8.21838 10.5722 7.86222 10.3525 7.64255C10.1328 7.42288 9.77669 7.42288 9.55702 7.64255L8.36376 8.83581L7.1705 7.64255C6.95083 7.42288 6.59467 7.42288 6.375 7.64255C6.15533 7.86222 6.15533 8.21838 6.375 8.43805L7.56826 9.6313L6.37503 10.8245C6.15536 11.0442 6.15536 11.4004 6.37503 11.62C6.5947 11.8397 6.95085 11.8397 7.17052 11.62L8.36376 10.4268L9.55699 11.62C9.77666 11.8397 10.1328 11.8397 10.3525 11.62C10.5722 11.4004 10.5722 11.0442 10.3525 10.8245L9.15925 9.6313Z"
        fill="currentColor"
      />
      <path
        d="M5.625 1.365C5.10723 1.365 4.6875 1.78473 4.6875 2.3025L4.6875 4.49992H5.8125C6.12316 4.49992 6.375 4.75176 6.375 5.06242C6.375 5.37308 6.12316 5.62492 5.8125 5.62492H4.6875L4.6875 9.6313C4.6875 10.7704 3.76409 11.6938 2.625 11.6938C1.48591 11.6938 0.5625 10.7704 0.5625 9.6313C0.5625 9.32064 0.81434 9.0688 1.125 9.0688C1.43566 9.0688 1.6875 9.32064 1.6875 9.6313C1.6875 10.1491 2.10723 10.5688 2.625 10.5688C3.14277 10.5688 3.5625 10.1491 3.5625 9.6313L3.5625 5.62492H2.4375C2.12684 5.62492 1.875 5.37308 1.875 5.06242C1.875 4.75176 2.12684 4.49992 2.4375 4.49992H3.5625L3.5625 2.3025C3.5625 1.16341 4.48591 0.239999 5.625 0.239999C6.76409 0.239999 7.6875 1.16341 7.6875 2.3025C7.6875 2.61316 7.43566 2.865 7.125 2.865C6.81434 2.865 6.5625 2.61316 6.5625 2.3025C6.5625 1.78473 6.14277 1.365 5.625 1.365Z"
        stroke="currentColor"
        strokeWidth="0.4"
        strokeLinecap="round"
      />
      <path
        d="M9.15925 9.6313L10.3525 8.43805C10.5722 8.21838 10.5722 7.86222 10.3525 7.64255C10.1328 7.42288 9.77669 7.42288 9.55702 7.64255L8.36376 8.83581L7.1705 7.64255C6.95083 7.42288 6.59467 7.42288 6.375 7.64255C6.15533 7.86222 6.15533 8.21838 6.375 8.43805L7.56826 9.6313L6.37503 10.8245C6.15536 11.0442 6.15536 11.4004 6.37503 11.62C6.5947 11.8397 6.95085 11.8397 7.17052 11.62L8.36376 10.4268L9.55699 11.62C9.77666 11.8397 10.1328 11.8397 10.3525 11.62C10.5722 11.4004 10.5722 11.0442 10.3525 10.8245L9.15925 9.6313Z"
        stroke="currentColor"
        strokeWidth="0.4"
        strokeLinecap="round"
      />
    </g>
  ),
})
export const OrderedListSmallIcon = makeIcon({
  displayName: 'OrderedListSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 2.25C4.25 1.83579 4.58579 1.5 5 1.5H11.25C11.6642 1.5 12 1.83579 12 2.25C12 2.66421 11.6642 3 11.25 3H5C4.58579 3 4.25 2.66421 4.25 2.25ZM4.25 6C4.25 5.58579 4.58579 5.25 5 5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H5C4.58579 6.75 4.25 6.41421 4.25 6ZM4.25 9.75C4.25 9.33579 4.58579 9 5 9H11.25C11.6642 9 12 9.33579 12 9.75C12 10.1642 11.6642 10.5 11.25 10.5H5C4.58579 10.5 4.25 10.1642 4.25 9.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.936786 2.09225V4.65816C0.936786 4.93008 1.15722 5.15052 1.42915 5.15052C1.70107 5.15052 1.92151 4.93008 1.92151 4.65816V0.899902H1.71959L0.272952 1.4301C0.109004 1.49019 0 1.64623 0 1.82085C0 2.10237 0.273697 2.30267 0.542036 2.21752L0.936786 2.09225ZM0.141599 10.4019C0.0509388 10.4925 0 10.6154 0 10.7435C0 11.0102 0.216225 11.2265 0.482952 11.2265H2.61572C2.84752 11.2265 3.03543 11.0386 3.03543 10.8068C3.03543 10.575 2.84752 10.387 2.61572 10.387H1.44075L2.19333 9.59832C2.39983 9.37348 2.60242 9.13224 2.7404 8.85794C2.99214 8.35747 2.97664 7.684 2.52724 7.2965C2.05959 6.89326 1.25619 6.87402 0.723685 7.15921C0.494521 7.28194 0.315426 7.45258 0.188842 7.67054C0.128588 7.77429 0.0860348 7.88162 0.0567819 7.99195C-0.0140315 8.25905 0.224005 8.48763 0.500329 8.48763C0.776653 8.48763 0.947688 8.23476 1.10231 8.00574C1.11169 7.99184 1.12195 7.97822 1.13314 7.96493C1.28528 7.78426 1.6306 7.74894 1.79496 7.93399C1.97141 8.13265 1.91369 8.4389 1.79059 8.64679C1.71004 8.78281 1.58323 8.94611 1.4073 9.13725L0.141599 10.4019Z"
        fill="currentColor"
      />
    </g>
  ),
})
export const OutlineSmallIcon = makeIcon({
  displayName: 'OutlineSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.5C0 2.08579 0.335786 1.75 0.75 1.75H8.5C8.91421 1.75 9.25 2.08579 9.25 2.5C9.25 2.91421 8.91421 3.25 8.5 3.25H0.75C0.335786 3.25 0 2.91421 0 2.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 6C2.5 5.58579 2.83579 5.25 3.25 5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H3.25C2.83579 6.75 2.5 6.41421 2.5 6Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9.5C0 9.08579 0.335786 8.75 0.75 8.75H8.5C8.91421 8.75 9.25 9.08579 9.25 9.5C9.25 9.91421 8.91421 10.25 8.5 10.25H0.75C0.335786 10.25 0 9.91421 0 9.5Z"
      />
    </g>
  ),
})
export const SeparatorSmallIcon = makeIcon({
  displayName: 'SeparatorSmallIcon',
  viewBox: 12,
  content: (
    <rect
      x="12"
      y="5.4375"
      width="1.5"
      height="12"
      rx="0.75"
      transform="rotate(90 12 5.4375)"
      fill="currentColor"
    />
  ),
})
export const StrikethroughSmallIcon = makeIcon({
  displayName: 'StrikethroughSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5.8125C0 5.50184 0.25184 5.25 0.5625 5.25H11.4375C11.7482 5.25 12 5.50184 12 5.8125C12 6.12316 11.7482 6.375 11.4375 6.375H0.5625C0.25184 6.375 0 6.12316 0 5.8125Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.81251 0.00756836C3.04224 0.00756836 1.32001 1.817 1.32001 3.75007C1.32001 4.23716 1.40679 4.67899 1.5735 5.07007H0.771553C0.361481 5.07007 0.0290527 5.4025 0.0290527 5.81257C0.0290527 6.22264 0.361481 6.55507 0.771553 6.55507H3.45128L3.4513 6.55508H6.55501V6.55507H11.2469C11.6569 6.55507 11.9894 6.22264 11.9894 5.81257C11.9894 5.4025 11.6569 5.07007 11.2469 5.07007H3.4099C3.02744 4.78866 2.80501 4.38357 2.80501 3.75007C2.80501 2.78187 3.70975 1.49257 5.81251 1.49257C6.82166 1.49257 7.49126 1.87484 7.91304 2.24539C8.12783 2.43408 8.2805 2.62225 8.37754 2.75991C8.42581 2.82839 8.45949 2.88318 8.47948 2.91758C8.48414 2.9256 8.48916 2.93457 8.49319 2.94186L8.49831 2.95119C8.67914 3.3118 9.12249 3.47239 9.49134 3.29228C9.85983 3.11235 10.0128 2.66773 9.83285 2.29924L9.82626 2.28683L9.82545 2.2853L9.82543 2.28526C9.81238 2.26066 9.78197 2.20336 9.76341 2.17143C9.72382 2.10329 9.66692 2.0116 9.59127 1.90429C9.44049 1.69039 9.21192 1.40981 8.89314 1.12975C8.24786 0.56287 7.24095 0.00756836 5.81251 0.00756836ZM9.98054 7.3201H8.40363L8.49698 7.56436C8.56848 7.75143 8.61047 7.97644 8.61047 8.25008C8.61047 9.21828 7.70573 10.5076 5.60297 10.5076C4.59382 10.5076 3.92422 10.1253 3.50244 9.75477C3.28765 9.56607 3.13498 9.37791 3.03794 9.24024C2.99325 9.17684 2.93723 9.08251 2.91294 9.04084C2.73023 8.67987 2.2899 8.52928 1.92414 8.70787C1.55565 8.8878 1.40278 9.33239 1.58271 9.70088L1.58412 9.70368L1.58636 9.70809L1.59204 9.71923L1.6052 9.74468C1.61668 9.76628 1.63224 9.79462 1.65207 9.82872C1.69166 9.89686 1.74856 9.98856 1.82421 10.0959C1.975 10.3098 2.20356 10.5903 2.52234 10.8704C3.16762 11.4373 4.17453 11.9926 5.60297 11.9926C8.37324 11.9926 10.0955 10.1832 10.0955 8.25008C10.0955 7.97469 10.0678 7.71105 10.012 7.46087L9.98054 7.3201Z"
        fill="currentColor"
      />
    </g>
  ),
})
export const SubscriptSmallIcon = makeIcon({
  displayName: 'SubscriptSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2.75C0 2.33579 0.335786 2 0.75 2H6.75C7.16421 2 7.5 2.33579 7.5 2.75C7.5 3.16421 7.16421 3.5 6.75 3.5H4.5L4.5 9.5C4.5 9.91421 4.16421 10.25 3.75 10.25C3.33579 10.25 3 9.91421 3 9.5L3 3.5H0.75C0.335786 3.5 0 3.16421 0 2.75ZM9.2317 8.15655C9.41217 7.921 9.73736 7.8833 9.96284 8.06294C10.1954 8.24819 10.2404 8.5987 10.0546 8.84117C9.88306 9.06504 9.42174 9.5786 8.97992 10.0597C8.76391 10.295 8.55961 10.5149 8.40924 10.6761C8.33409 10.7566 8.27249 10.8224 8.22972 10.8681L8.16328 10.9388C7.9992 11.1131 7.95442 11.3683 8.04936 11.588C8.14429 11.8078 8.36077 11.9501 8.60015 11.9501L11.0001 11.9501C11.3315 11.9501 11.6001 11.6815 11.6001 11.3501C11.6001 11.0187 11.3315 10.7501 11.0002 10.7501L9.97497 10.7501C10.3756 10.3121 10.8137 9.82347 11.0071 9.57101C11.5874 8.81361 11.4586 7.7203 10.7106 7.12437C9.9555 6.52282 8.86476 6.6624 8.27915 7.42672C8.18025 7.5558 8.1017 7.69514 8.04338 7.84035C7.91989 8.14785 8.06905 8.49724 8.37655 8.62074C8.68404 8.74424 9.03343 8.59507 9.15693 8.28758C9.17524 8.24199 9.19998 8.19794 9.2317 8.15655Z"
      fill="currentColor"
    />
  ),
})
export const SuperscriptSmallIcon = makeIcon({
  displayName: 'SuperscriptSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.4817 1.40655C9.66217 1.171 9.98736 1.1333 10.2128 1.31294C10.4454 1.49819 10.4904 1.8487 10.3046 2.09117C10.1331 2.31504 9.67174 2.82859 9.22992 3.30974C9.01391 3.54499 8.80961 3.76491 8.65924 3.92609C8.58409 4.00665 8.52249 4.07245 8.47972 4.11806L8.41328 4.18881C8.2492 4.36312 8.20442 4.61828 8.29936 4.83803C8.39429 5.05778 8.61077 5.20008 8.85015 5.20008L11.2501 5.2001C11.5815 5.2001 11.8501 4.93147 11.8501 4.6001C11.8501 4.26873 11.5815 4.0001 11.2502 4.00009L10.225 4.00009C10.6256 3.56208 11.0637 3.07347 11.2571 2.82101C11.8374 2.06361 11.7086 0.970299 10.9606 0.37437C10.2055 -0.227179 9.11476 -0.0875998 8.52915 0.676718C8.43025 0.805803 8.3517 0.945141 8.29338 1.09035C8.16989 1.39785 8.31905 1.74724 8.62655 1.87074C8.93404 1.99424 9.28343 1.84507 9.40693 1.53758C9.42524 1.49199 9.44998 1.44794 9.4817 1.40655ZM0 2.75C0 2.33579 0.335786 2 0.75 2H6.5C6.91421 2 7.25 2.33579 7.25 2.75C7.25 3.16421 6.91421 3.5 6.5 3.5H4.5L4.5 9.5C4.5 9.91421 4.16421 10.25 3.75 10.25C3.33579 10.25 3 9.91421 3 9.5L3 3.5H0.75C0.335786 3.5 0 3.16421 0 2.75Z"
      fill="currentColor"
    />
  ),
})
export const TableSmallIcon = makeIcon({
  displayName: 'TableSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.25 1.5C0.25 0.671573 0.921573 0 1.75 0H10.25C11.0784 0 11.75 0.671573 11.75 1.5V10.5C11.75 11.3284 11.0784 12 10.25 12H6.75H5.25H1.75C0.921573 12 0.25 11.3284 0.25 10.5V1.5ZM10.25 10.5H6.75V7H10.25V10.5ZM10.25 5.5H6.75V2H10.25V5.5ZM5.25 5.5V2H1.75V5.5H5.25ZM1.75 7V10.5H5.25V7H1.75Z"
      fill="currentColor"
    />
  ),
})
export const TextPlaceholderSmallIcon = makeIcon({
  displayName: 'TextPlaceholderSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.74933 0C2.33512 0 1.99933 0.335786 1.99933 0.75C1.99933 0.769067 2.00004 0.787968 2.00144 0.806678C2.00048 0.82223 1.99999 0.83791 1.99999 0.853703L1.99999 2C1.99999 2.41421 2.33578 2.75 2.74999 2.75C3.1642 2.75 3.49999 2.41421 3.49999 2L3.49999 1.5H5.24999L5.24999 6.75H4.24999C3.83577 6.75 3.49999 7.08579 3.49999 7.5C3.49999 7.91421 3.83577 8.25 4.24999 8.25H5.99999H7.74999C8.1642 8.25 8.49999 7.91421 8.49999 7.5C8.49999 7.08579 8.1642 6.75 7.74999 6.75H6.74999L6.74999 1.5H8.49999V2C8.49999 2.41421 8.83578 2.75 9.24999 2.75C9.6642 2.75 9.99999 2.41421 9.99999 2L9.99999 0.848585C9.99999 0.819347 9.99831 0.790499 9.99506 0.762132L9.99516 0.75C9.99516 0.335786 9.65937 0 9.24516 0H2.74933ZM1.5 10.5C1.08579 10.5 0.75 10.8358 0.75 11.25C0.75 11.6642 1.08579 12 1.5 12H2.75C3.16421 12 3.5 11.6642 3.5 11.25C3.5 10.8358 3.16421 10.5 2.75 10.5H1.5ZM4.5 11.25C4.5 10.8358 4.83579 10.5 5.25 10.5H6.5C6.91421 10.5 7.25 10.8358 7.25 11.25C7.25 11.6642 6.91421 12 6.5 12H5.25C4.83579 12 4.5 11.6642 4.5 11.25ZM9.25 10.5C8.83579 10.5 8.5 10.8358 8.5 11.25C8.5 11.6642 8.83579 12 9.25 12H10.5C10.9142 12 11.25 11.6642 11.25 11.25C11.25 10.8358 10.9142 10.5 10.5 10.5H9.25Z"
      fill="currentColor"
    />
  ),
})
export const UnderlineSmallIcon = makeIcon({
  displayName: 'UnderlineSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 0.75C3.25 0.335786 2.91421 0 2.5 0C2.08579 0 1.75 0.335786 1.75 0.75V5C1.75 7.34721 3.65279 9.25 6 9.25C8.34721 9.25 10.25 7.34721 10.25 5V0.75C10.25 0.335786 9.91421 0 9.5 0C9.08579 0 8.75 0.335786 8.75 0.75V5C8.75 6.51878 7.51878 7.75 6 7.75C4.48122 7.75 3.25 6.51878 3.25 5V0.75ZM2.25 10.5C1.83579 10.5 1.5 10.8358 1.5 11.25C1.5 11.6642 1.83579 12 2.25 12H9.75C10.1642 12 10.5 11.6642 10.5 11.25C10.5 10.8358 10.1642 10.5 9.75 10.5H2.25Z"
      fill="currentColor"
    />
  ),
})
export const VideoSmallIcon = makeIcon({
  displayName: 'VideoSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.75 1.25C0.783502 1.25 0 2.0335 0 3L3.8147e-06 8.99992C3.8147e-06 9.96642 0.783504 10.7499 1.75 10.7499H7.35701C8.32351 10.7499 9.10701 9.96642 9.10701 8.99992V8.60602L10.7903 8.86499C11.4264 8.96284 12 8.47073 12 7.8272V4.175C12 3.52544 11.4161 3.0317 10.7756 3.13958L9.107 3.4206V3C9.107 2.0335 8.3235 1.25 7.357 1.25H1.75ZM9.10701 4.94173L9.10701 7.08837L10.5 7.30268V4.70712L9.10701 4.94173ZM1.5 3C1.5 2.86193 1.61193 2.75 1.75 2.75H7.357C7.49507 2.75 7.607 2.86193 7.607 3L7.60701 8.99992C7.60701 9.138 7.49508 9.24992 7.35701 9.24992H1.75C1.61193 9.24992 1.5 9.138 1.5 8.99992L1.5 3Z"
      fill="currentColor"
    />
  ),
})

export const QuoteSmallIcon = makeIcon({
  displayName: 'QuoteSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.39874 2.33529C5.32956 1.94792 4.95946 1.68997 4.57208 1.75914C1.78133 2.25749 0.260904 4.41843 0.0309498 6.46628C-0.0835897 7.4863 0.11588 8.53 0.694642 9.33889C1.23189 10.0898 2.05973 10.5845 3.11631 10.6736C3.23049 10.689 3.34712 10.6969 3.4656 10.6969C4.7917 10.6969 5.8876 9.7019 5.8876 8.44971C5.8876 7.19752 4.7917 6.20247 3.4656 6.20247C2.61842 6.20247 1.8652 6.60858 1.43164 7.22839C1.41906 7.03522 1.4237 6.83326 1.44705 6.62529C1.61446 5.13438 2.71949 3.5375 4.82259 3.16195C5.20996 3.09278 5.46791 2.72267 5.39874 2.33529ZM11.3614 2.33529C11.2922 1.94792 10.9221 1.68997 10.5347 1.75914C7.74398 2.25749 6.22355 4.41843 5.9936 6.46628C5.87906 7.4863 6.07853 8.53 6.65729 9.33889C7.19454 10.0898 8.02238 10.5845 9.07895 10.6736C9.19313 10.689 9.30977 10.6969 9.42824 10.6969C10.7543 10.6969 11.8502 9.7019 11.8502 8.44971C11.8502 7.19752 10.7543 6.20247 9.42824 6.20247C8.58107 6.20247 7.82784 6.60858 7.39428 7.22839C7.3817 7.03522 7.38634 6.83326 7.4097 6.62529C7.57711 5.13438 8.68213 3.5375 10.7852 3.16195C11.1726 3.09278 11.4306 2.72267 11.3614 2.33529Z"
      fill="currentColor"
    />
  ),
})

export const CollectionLinkSmallIcon = makeIcon({
  displayName: 'CollectionLinkSmallIcon',
  viewBox: 12,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.75 0.75C2.75 0.335786 3.08579 0 3.5 0H5.25C5.66421 0 6 0.335786 6 0.75C6 1.16421 5.66421 1.5 5.25 1.5H3.5C3.08579 1.5 2.75 1.16421 2.75 0.75ZM2.25 3C1.83579 3 1.5 3.33579 1.5 3.75C1.5 4.16421 1.83579 4.5 2.25 4.5H5.25C5.66421 4.5 6 4.16421 6 3.75C6 3.33579 5.66421 3 5.25 3H2.25ZM1.5 10.5V7.5H10.5V10.5H1.5ZM0 7.5C0 6.67157 0.671573 6 1.5 6H10.5C11.3284 6 12 6.67157 12 7.5V10.5C12 11.3284 11.3284 12 10.5 12H1.5C0.671573 12 0 11.3284 0 10.5V7.5ZM7.24964 0.765368C7.24957 1.17965 7.58535 1.51544 7.99964 1.51537L9.44212 1.51545L7.50016 3.43909C7.20716 3.73209 7.20708 4.20704 7.49997 4.49994C7.79286 4.79283 8.26782 4.79275 8.56082 4.49975L10.5041 2.57484L10.5041 4.00023C10.5041 4.41452 10.8399 4.75031 11.2541 4.75024C11.6684 4.75016 12.0043 4.41426 12.0044 3.99997L12.0044 0.765118C12.0045 0.350831 11.6687 0.015045 11.2544 0.0151183L7.9999 0.0151023C7.58562 0.0151757 7.24971 0.351081 7.24964 0.765368Z"
      fill="currentColor"
    />
  ),
})

export const IdCodeSmallIcon = makeIcon({
  displayName: 'IdCodeSmallIcon',
  viewBox: 12,
  content: (
    <>
      <path d="M5.523.033a.75.75 0 0 1 .497.938L4.66 5.389a.75.75 0 0 1-1.433-.441L4.586.53a.75.75 0 0 1 .937-.497ZM2.64 2.13a.75.75 0 0 0-1.061-1.06L.219 2.43a.75.75 0 0 0 0 1.06l1.36 1.36a.75.75 0 0 0 1.06-1.061l-.828-.83.829-.828Zm3.97.001a.75.75 0 1 1 1.061-1.06l1.36 1.359a.75.75 0 0 1 0 1.06L7.67 4.85a.75.75 0 0 1-1.06-1.06l.828-.83-.829-.829Z" />
      <path d="M10 0a.75.75 0 0 0 0 1.5h.125c.207 0 .375.169.375.376v8.25a.375.375 0 0 1-.375.375h-8.25a.375.375 0 0 1-.375-.375V6.75a.75.75 0 0 0-1.5 0v3.375C0 11.16.84 12 1.875 12h8.25C11.161 12 12 11.16 12 10.126v-8.25C12 .84 11.16 0 10.125 0H10Z" />
    </>
  ),
})

export const InlineCodeSmallIcon = makeIcon({
  displayName: 'InlineCodeSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.06066 3.43934C3.35355 3.73223 3.35355 4.20711 3.06066 4.5L1.81066 5.97897L3.06066 7.27448C3.35355 7.56737 3.35355 8.04225 3.06066 8.33514C2.76777 8.62803 2.29289 8.62803 2 8.33514L0.21967 6.5093C-0.0732233 6.21641 -0.0732233 5.74154 0.21967 5.44864L2 3.43934C2.29289 3.14645 2.76777 3.14645 3.06066 3.43934Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 3.43934C8.70711 3.73223 8.70711 4.20711 9 4.5L10.1893 5.97898L9 7.27448C8.70711 7.56738 8.70711 8.04225 9 8.33514C9.29289 8.62804 9.76777 8.62804 10.0607 8.33514L11.7803 6.50931C12.0732 6.21641 12.0732 5.74154 11.7803 5.44865L10.0607 3.43934C9.76777 3.14645 9.29289 3.14645 9 3.43934Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.83541 8.50634C4.46493 8.3211 4.31476 7.87059 4.5 7.50011L6.32918 3.61054C6.51442 3.24006 6.96493 3.08989 7.33541 3.27513C7.70589 3.46037 7.85606 3.91088 7.67082 4.28136L5.84164 8.17093C5.6564 8.54141 5.20589 8.69158 4.83541 8.50634Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const SuccessFilledSmallIcon: React.FC<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 12 12">
    <circle cx="6" cy="6" r="6" opacity={'0.2'} />
    <path
      d="M8.76 4.22a.75.75 0 0 1 0 1.06L5.74 8.3a.75.75 0 0 1-1.061 0l-1.46-1.459a.75.75 0 0 1 1.061-1.06l.93.928 2.489-2.49a.75.75 0 0 1 1.06 0Z"
      fill="currentColor"
    />
  </IconBase>
)

export const CircledCrossFilledSmallIcon: React.FC<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 12 12">
    <circle cx="6" cy="6" r="6" opacity={'0.2'} />
    <path
      d="M3.97 3.97a.75.75 0 0 1 1.06 0l.97.97.97-.97a.75.75 0 0 1 1.06 1.06L7.06 6l.97.97a.75.75 0 0 1-1.06 1.06L6 7.06l-.97.97a.75.75 0 0 1-1.06-1.06L4.94 6l-.97-.97a.75.75 0 0 1 0-1.06Z"
      fill="currentColor"
    />
  </IconBase>
)

export const ClockFilledSmallIcon: React.FC<IconBaseProps> = (props) => (
  <IconBase {...props} viewBox="0 0 12 12">
    <circle cx="6" cy="6" r="6" opacity={'0.2'} />
    <path
      d="M6.5 3.5a.75.75 0 1 0-1.5 0v2.75c0 .414.336.75.75.75h2.5a.75.75 0 0 0 0-1.5H6.5v-2Z"
      fill="currentColor"
    />
  </IconBase>
)

export const ApplyFormatSmallIcon = makeIcon({
  displayName: 'ApplyFormatSmallIcon',
  viewBox: 12,
  content: (
    <>
      <path
        d="M0.75 0C0.335786 0 0 0.335786 0 0.75C0 1.16421 0.335786 1.5 0.75 1.5H11.203C11.6172 1.5 11.953 1.16421 11.953 0.75C11.953 0.335786 11.6172 0 11.203 0H0.75Z"
        fill="currentColor"
      />
      <path
        d="M0.75 3.5C0.335786 3.5 0 3.83579 0 4.25C0 4.66421 0.335786 5 0.75 5H5C5.41421 5 5.75 4.66421 5.75 4.25C5.75 3.83579 5.41421 3.5 5 3.5H0.75Z"
        fill="currentColor"
      />
      <path
        d="M0.75 7C0.335786 7 0 7.33579 0 7.75C0 8.16421 0.335786 8.5 0.75 8.5H2.5C2.91421 8.5 3.25 8.16421 3.25 7.75C3.25 7.33579 2.91421 7 2.5 7H0.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.92301 3.67099C9.96982 3.41958 9.84975 3.16654 9.63097 3.05555C9.41219 2.94455 9.14999 3.00365 8.99324 3.19928L5.37602 7.71367C5.2484 7.87295 5.21477 8.09369 5.28864 8.28717C5.36251 8.48066 5.53175 8.6151 5.72833 8.63646L7.77397 8.85873L7.32645 11.3319C7.28101 11.5831 7.40173 11.835 7.62031 11.9451C7.83889 12.0552 8.10035 11.9959 8.25676 11.8007L11.874 7.28633C11.9997 7.12942 12.0344 6.91264 11.9644 6.72087C11.8944 6.52911 11.7309 6.3929 11.5379 6.36558L9.47571 6.0736L9.92301 3.67099ZM8.46094 7.80244L6.84174 7.6265L8.4814 5.58015L8.32073 6.44318C8.2924 6.59538 8.32486 6.75317 8.41044 6.87926C8.49603 7.00534 8.62714 7.08853 8.77278 7.10915L10.4319 7.34404L8.75425 9.43776L8.92981 8.46751C8.95782 8.31271 8.92302 8.15261 8.83389 8.02617C8.74476 7.89974 8.60946 7.81858 8.46094 7.80244Z"
        fill="currentColor"
      />
    </>
  ),
})

export const AudioSmallIcon = makeIcon({
  displayName: 'AudioSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 1.75C4.89227 1.75 3.81706 2.22472 3.01479 3.09118C2.21071 3.95958 1.75 5.14891 1.75 6.4V10C1.75 10.4142 1.41421 10.75 1 10.75C0.585786 10.75 0.25 10.4142 0.25 10V6.4C0.25 4.78675 0.842855 3.22906 1.91415 2.07207C2.98724 0.91313 4.45557 0.25 6 0.25C7.54444 0.25 9.01276 0.913131 10.0859 2.07207C11.1571 3.22906 11.75 4.78675 11.75 6.4V10C11.75 10.4142 11.4142 10.75 11 10.75C10.5858 10.75 10.25 10.4142 10.25 10V6.4C10.25 5.14891 9.78929 3.95958 8.98521 3.09118C8.18294 2.22472 7.10773 1.75 6 1.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 7C0.25 6.58579 0.585786 6.25 1 6.25H2.77838C3.2789 6.25 3.75451 6.45471 4.1018 6.81193C4.4484 7.16842 4.63949 7.64755 4.63949 8.14286V9.85714C4.63949 10.3524 4.4484 10.8316 4.1018 11.1881C3.75451 11.5453 3.2789 11.75 2.77838 11.75H2.11111C1.61059 11.75 1.13498 11.5453 0.787691 11.1881C0.441096 10.8316 0.25 10.3524 0.25 9.85714V7ZM1.75 7.75V9.85714C1.75 9.96805 1.79303 10.0703 1.86318 10.1425C1.93264 10.2139 2.02227 10.25 2.11111 10.25H2.77838C2.86723 10.25 2.95685 10.2139 3.02631 10.1425C3.09646 10.0703 3.13949 9.96805 3.13949 9.85714V8.14286C3.13949 8.03195 3.09646 7.9297 3.02631 7.85754C2.95685 7.7861 2.86723 7.75 2.77838 7.75H1.75ZM9.22638 7.75C9.13754 7.75 9.04791 7.7861 8.97846 7.85754C8.9083 7.9297 8.86527 8.03196 8.86527 8.14286V9.85714C8.86527 9.96804 8.9083 10.0703 8.97846 10.1425C9.04791 10.2139 9.13754 10.25 9.22638 10.25H9.88889C9.97774 10.25 10.0674 10.2139 10.1368 10.1425C10.207 10.0703 10.25 9.96805 10.25 9.85714V7.75H9.22638ZM7.90296 6.81193C8.25026 6.45471 8.72586 6.25 9.22638 6.25H11C11.4142 6.25 11.75 6.58579 11.75 7V9.85714C11.75 10.3524 11.5589 10.8316 11.2123 11.1881C10.865 11.5453 10.3894 11.75 9.88889 11.75H9.22638C8.72586 11.75 8.25026 11.5453 7.90296 11.1881C7.55637 10.8316 7.36527 10.3525 7.36527 9.85714V8.14286C7.36527 7.64755 7.55637 7.16842 7.90296 6.81193Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const ExternalLinkSmallIcon = makeIcon({
  displayName: 'ExternalLinkSmallIcon',
  viewBox: 12,
  content: (
    <g>
      <path
        d="M11.2503 0C11.6644 0.000162478 12.0003 0.335887 12.0003 0.75V3.75C12.0003 4.16411 11.6644 4.49984 11.2503 4.5C10.8361 4.5 10.5003 4.16421 10.5003 3.75V2.48242L7.57745 5.40527C7.28454 5.69802 6.80975 5.69812 6.5169 5.40527C6.2241 5.11243 6.22417 4.63762 6.5169 4.34473L9.36163 1.5H8.2503C7.83609 1.5 7.5003 1.16421 7.5003 0.75C7.5003 0.335786 7.83609 9.05292e-09 8.2503 0H11.2503Z"
        fill="currentColor"
      />
      <path
        d="M1.5 2.625L1.5 9.375C1.5 9.99632 2.00368 10.5 2.625 10.5L9.375 10.5C9.99632 10.5 10.5 9.99632 10.5 9.375V7.81055C10.5 7.39633 10.8358 7.06055 11.25 7.06055C11.6642 7.06055 12 7.39633 12 7.81055V9.375C12 10.8247 10.8247 12 9.375 12L2.625 12C1.17525 12 -1.26741e-07 10.8247 0 9.375L5.90104e-07 2.625C7.57111e-07 1.17525 1.17525 2.05065e-07 2.625 1.34086e-07L4.18945 2.70855e-07C4.60367 3.07067e-07 4.93945 0.335787 4.93945 0.75C4.93945 1.16421 4.60367 1.5 4.18945 1.5L2.625 1.5C2.00368 1.5 1.5 2.00368 1.5 2.625Z"
        fill="currentColor"
      />
    </g>
  ),
})
